{
  "filtra_per_data": "Filtra per data",
  "tipologia_pulmino": "Tipologia pulmino",
  "disposizione_posti": "Disposizione posti",
  "rinomina": "Rinomina",
  "sposta": "Sposta",
  "nuova_cartella": "Nuova cartella",
  "nome_cartella": "Nome cartella",
  "ordina": "Ordina",
  "modificato": "Modificato",
  "dimensione": "Dimensione",
  "data_e_ora": "Data e ora",
  "rilascia_per_caricare": "Rilascia per caricare",
  "sicuro_sposta": "Spostare \"{{name}}\" qui?",
  "sicuro_rimuovi_cartella": "Eliminare la cartella e tutto il suo contenuto?",
  "documento_spostato_successo": "Documento spostato",
  "errore_spostamento": "Errore nello spostamento",
  "documento_rinominato_successo": "Documento rinominato",
  "errore_rinomina": "Errore nella rinomina",
  "seat_cycle_hint": "Click per ciclare: passeggero → carrozzina → vuoto",
  "posto_autista": "Autista",
  "posto_passeggero": "Passeggero",
  "posto_carrozzina": "Carrozzina",
  "posto_vuoto": "Vuoto",
  "modifica_tipologia": "Modifica tipologia",
  "nuova_tipologia": "Nuova tipologia",
  "nome_tipologia": "Nome tipologia",
  "nome_tipologia_placeholder": "es. Minibus 9 posti, Minibus 15 posti WC",
  "posti_totali": "Posti totali (incl. autista)",
  "posti_passeggeri": "Posti passeggeri",
  "layout_posti": "Layout posti",
  "file": "File",
  "colonne": "Colonne",
  "posto_autista_hint": "Il posto in alto a sinistra è sempre l'autista",
  "salva_modifiche": "Salva modifiche",
  "crea_tipologia": "Crea tipologia",
  "tipologie_pulmino": "Tipologie Pulmino",
  "nessuna_tipologia": "Nessuna tipologia configurata",
  "layout": "Layout",
  "sicuro_rimuovi_tipologia": "Eliminare la tipologia \"{{name}}\"?",
  "salvataggio_riuscito": "Salvataggio riuscito",
  "errore_salvataggio": "Errore durante il salvataggio",
  "errore_aggiornamento": "Errore durante l'aggiornamento",
  "errore_caricamento": "Errore nel caricamento",
  "abilita": "Abilita",
  "disabilita": "Disabilita",
  "mostra_credenziali": "Mostra credenziali",
  "nascondi_credenziali": "Nascondi credenziali",
  "nessun_documento": "Nessun documento",
  "rimuovi": "Rimuovi",
  "nessun_evento": "Nessun evento",
  "nessun_turno": "Nessun turno trovato per questo mese",
  "totale_mensile": "Totale Mensile",
  "mese_precedente": "Mese precedente",
  "mese_successivo": "Mese successivo",
  "inizio_turno": "Inizio turno",
  "fine_turno": "Fine turno",
  "totale_transato": "Totale transato:",
  "totale_viaggi": "Totale viaggi:",
  "transato_gestore": "Transato per gestore",
  "viaggi_gestore": "Viaggi per gestore",
  "transato_contratto": "Transato per contratto",
  "viaggi_contratto": "Viaggi per contratto",
  "dettaglio_check": "Dettaglio check",
  "dati_check": "Dati check",
  "chilometri": "Chilometri",
  "ultimo_controllo_acqua": "Ultimo controllo acqua",
  "ultimo_controllo_olio": "Ultimo controllo olio",
  "sottomesso_da": "Sottomesso da",
  "fotografie": "FOTOGRAFIE",
  "check_giornalieri": "Check giornalieri",
  "esporta_csv": "Esporta in CSV",
  "elenco_check": "Elenco check",
  "autista": "Autista",
  "secondo_op": "Secondo operatore",
  "orario_non_valido": "Orario non valido",
  "km": "km",
  "acqua": "Acqua",
  "olio": "Olio",
  "immagini_caricate": "Immagini caricate",
  "azioni": "Azioni",
  "contratto": "Contratto",
  "dati_contratto": "Dati del contratto",
  "codice_contratto": "Codice contratto",
  "cliente": "Cliente",
  "valido_fino_a": "Valido fino a",
  "prezzo": "Prezzo",
  "gestore": "Gestore",
  "email_di_notifica": "Email di notifica",
  "azienda": "Azienda",
  "numero_operatori": "Numero di operatori",
  "minuti_fermo_auto": "Minuti di fermo auto incluso",
  "aggiungi_cap": "Aggiungi CAP",
  "prepagato_utenti": "Prepagato per gli utenti APP e Sito",
  "andata_ritorno": "Andata e Ritorno",
  "indietro": "Indietro",
  "salva": "Salva",
  "opportunita": "Prospect",
  "codice": "Codice",
  "valido_fino": "Valido fino al",
  "aggiungi_gestore": "Aggiungi un gestore",
  "dati_gestore": "Dati gestore",
  "nome": "Nome",
  "cognome": "Cognome",
  "email": "Email",
  "password_primo_accesso": "Password primo accesso",
  "gestori": "Gestori",
  "super_gestore": "Super gestore",
  "abilita_super_gestore": "Vede i gestori associati",
  "gestori_associati": "Gestori associati",
  "seleziona_gestori": "Seleziona Gestori",
  "permessi_super": "Sezioni visibili degli associati",
  "flotta": "Flotta",
  "nessun_gestore": "Nessun gestore",
  "viaggio_giornaliero": "Viaggio giornaliero",
  "dati_viaggio": "Dati viaggio",
  "assegna_autista": "Assegna un autista",
  "nome_passeggero": "Nome e cognome",
  "indirizzo_partenza": "Indirizzo Partenza",
  "indirizzo_arrivo": "Indirizzo Arrivo",
  "orario_presa": "Orario presa",
  "valida_fino_al": "Valida fino al",
  "quali_giorni": "Quali giorni della settimana verrà effettuata la corsa?",
  "lun": "Lun",
  "mar": "Mar",
  "mer": "Mer",
  "gio": "Gio",
  "ven": "Ven",
  "sab": "Sab",
  "dom": "Dom",
  "viaggi_giornalieri": "Viaggi giornalieri",
  "aggiungi": "Aggiungi",
  "esporta": "Esporta",
  "viaggi_inseriti_description": "I viaggi inseriti nella sezione \"Viaggi giornalieri\", ogni Venerdì pomeriggio verranno automaticamente pianificati per la settimana successiva, da Lunedì a Domenica, lasciando 3 giorni per eventuali modifiche pre-servizio.",
  "elenco_corse_giornaliere": "Elenco corse giornaliere",
  "cerca_per_nome": "Cerca per nome, gestore, orario o indirizzo",
  "giorni": "Giorni",
  "passeggero": "Passeggero",
  "partenza": "Partenza",
  "arrivo": "Arrivo",
  "orario": "Orario",
  "nessun_viaggio_ricorrente": "Nessun viaggio ricorrente pianificato",
  "data": "Data",
  "stato": "Stato",
  "rifiutato": "Rifiutato",
  "inserito": "Inserito",
  "assegnato": "Assegnato",
  "vicino_casa": "Vicino casa",
  "arrivato": "Arrivato",
  "annullato": "Annullato",
  "a_bordo": "A bordo",
  "provenienza": "Provenienza",
  "dettagli": "Dettagli",
  "storico": "Storico",
  "cerca": "Cerca",
  "data_da": "Data da",
  "data_a": "Data a",
  "nessun_viaggio_in_corso": "Nessun Viaggio in corso",
  "viaggi_pianificati": "Viaggi pianificati",
  "accedi": "Accedi",
  "password": "Password",
  "password_dimenticata": "Hai dimenticato la password?",
  "entra": "Entra",
  "reimposta_password": "Reimposta la password",
  "reimposta": "Reimposta",
  "mappa": "Mappa",
  "aggiungi_mezzo": "Aggiungi mezzo",
  "dati_mezzo": "Dati mezzo",
  "targa": "Targa",
  "km_attuali": "km attuali",
  "data_revisione": "Data revisione",
  "data_omologazione": "Data omologazione",
  "data_assicurazione": "Data assicurazione",
  "dati_amministrativi": "Dati amministrativi",
  "registration_date": "Data immatricolazione",
  "euro_class": "Classe Euro",
  "ownership_type": "Tipo proprietà",
  "ownership_expiry": "Scadenza proprietà",
  "tyre_type": "Tipologia gomme",
  "permessi_licenze": "Permessi & Licenze",
  "dotazioni_di_bordo": "Dotazioni di bordo",
  "numero": "Numero",
  "manutenzione": "Manutenzione",
  "interventi": "interventi",
  "dati_intervento": "Dati intervento",
  "nuovo_intervento": "Nuovo intervento",
  "modifica_intervento": "Modifica intervento",
  "nessun_intervento": "Nessun intervento",
  "sicuro_rimuovi_intervento": "Eliminare questo intervento?",
  "fornitore": "Fornitore",
  "prossima_scadenza": "Prossima scadenza",
  "prossime_scadenze": "Prossime scadenze",
  "next_due_km": "Km prossima scadenza",
  "next_due_date": "Data prossima scadenza",
  "scadenza": "Scadenza",
  "scadenzario": "Scadenzario flotta",
  "scadenze_manutenzione": "Scadenze manutenzione e documenti",
  "nessuna_scadenza": "Nessuna scadenza rilevata",
  "categoria": "Categoria",
  "deadline_ok": "Regolare",
  "deadline_in_scadenza": "In scadenza",
  "deadline_scaduto": "Scaduto",
  "deadline_cat_maintenance": "Manutenzione",
  "deadline_cat_vehicle": "Mezzo",
  "deadline_cat_permit": "Permesso",
  "deadline_cat_equipment": "Dotazione",
  "foto": "Foto",
  "integrazioni": "Integrazioni",
  "provider_gps": "Provider GPS/Telemetria",
  "provider_ocr": "Provider OCR fatture",
  "api_key": "API key",
  "nessuno": "Nessuno",
  "salva_prima_di_aggiungere_foto": "Salva l'evento prima di aggiungere foto",
  "mezzi_aziendali": "Mezzi aziendali",
  "elenco_mezzi": "Elenco mezzi",
  "aggiungi_cliente_in_rubrica": "Aggiungi cliente in rubrica",
  "dati_cliente": "Dati cliente",
  "telefono": "Telefono",
  "cod_fisc": "Codice Fiscale",
  "indirizzo_preferito": "Indirizzo Preferito",
  "rubrica_clienti": "Rubrica clienti",
  "scarica_lista": "Scarica lista",
  "importa_da_ordini": "Importa",
  "nessun_cliente_in_rubrica": "Nessun cliente in rubrica",
  "patente": "Patente",
  "aggiungi_autista": "Aggiungi autista",
  "elenco_autisti": "Elenco autisti",
  "aggiungi_evento": "Aggiungi un evento",
  "modifica_evento": "Modifica evento",
  "da": "Da",
  "a": "A",
  "elimina": "Elimina",
  "foto_autista": "Foto autista",
  "trascina_qui": "Trascina qui oppure clicca per selezionare la foto dell'autista",
  "numero_patente": "Numero di patente",
  "valore_associato": "Valore associato",
  "scegli": "Scegli",
  "scegli_mezzo": "Scegli un mezzo",
  "indirizzo": "Indirizzo",
  "indirizzo_email": "Indirizzo Email",
  "num_telefono": "Numero di telefono",
  "aggiungi_cliente": "Aggiungi Cliente",
  "dalle": "Dalle",
  "alle": "alle",
  "destinazione": "Destinazione",
  "orario_partenza": "Orario di partenza",
  "pulmino_centro_diurno": "Pulmino centro diurno",
  "pulmino": "Pulmino",
  "elenco_presenze": "Elenco presenze",
  "segna_come_assente": "Segna come assente",
  "rimuovi_utente": "Rimuovi utente",
  "nessun_viaggio_pulmino": "Nessun viaggio su questo pulmino",
  "aggiungi_viaggio": "Aggiungi un viaggio",
  "dati_del_viaggio": "Dati del viaggio",
  "date_del_viaggio": "Data o date del viaggio",
  "orario_viaggio": "Orario",
  "prezzo_viaggio": "Prezzo viaggio",
  "prezzo_allettato": "Prezzo allettato",
  "tempo_viaggio": "Tempo stimato",
  "email_di_contatto": "Email di contatto",
  "data_ritorno": "Data del ritorno",
  "riepilogo": "Riepilogo",
  "link_pagamento": "Link di pagamento",
  "viaggio": "Viaggio",
  "service_mode": "Tipo servizio",
  "service_mode_transport": "Trasporto",
  "service_mode_transport_objects": "Trasporto oggetti",
  "service_mode_ambulance": "Ambulanza",
  "service_mode_assistance": "Assistenza",
  "service_mode_train": "Treno",
  "prenotazioni": "Prenotazioni",
  "prenotazione": "Prenotazione",
  "prenotazioni_sub": "Servizi multimodali",
  "nessuna_prenotazione": "Nessuna prenotazione",
  "nuova_prenotazione": "Nuova prenotazione",
  "aggiungi_servizio": "Aggiungi servizio",
  "servizio": "Servizio",
  "servizi": "Servizi",
  "nessun_servizio": "Nessun servizio configurato",
  "contract_services_hint": "Il contratto viene applicato solo alle prenotazioni che richiedono esattamente questi servizi. Lascia vuoto per un contratto a servizio singolo.",
  "contract_service_price_placeholder": "Vuoto = prezzo del contratto",
  "percentuale": "Percentuale (%)",
  "seleziona": "Seleziona...",
  "privato": "Privato",
  "rubrica": "Rubrica",
  "cerca_azienda": "Cerca azienda…",
  "cerca_cliente": "Cerca cliente…",
  "totale": "Totale",
  "distanza": "Distanza",
  "mappa_hint": "Compila almeno due tappe per la mappa.",
  "modello_prezzo": "Modello di prezzo",
  "pricing_manual": "Manuale",
  "pricing_fixed": "Prezzo fisso",
  "pricing_mbility": "Standard mbility",
  "pricing_custom_api": "API personalizzata",
  "api_url": "URL API pricing",
  "tariffa_base": "Tariffa",
  "soglia_ar_km": "Soglia A/R (km)",
  "moltiplicatori": "Moltiplicatori",
  "mult_weekend": "Weekend (es. 1.2)",
  "mult_night": "Notturno (es. 1.3)",
  "mult_double_operator": "Doppio operatore",
  "addizioni": "Addizioni",
  "add_dismissal": "Dimissione (€)",
  "add_require_wheelchair": "Carrozzina (€)",
  "prezzo_fisso": "Prezzo fisso (€)",
  "prezzo_base": "Prezzo base",
  "prezzo_km": "€/km",
  "prezzo_min": "€/min",
  "campi_personalizzati": "Campi personalizzati",
  "aggiungi_campo": "Aggiungi campo",
  "nessun_campo": "Nessun campo personalizzato.",
  "chiave": "Chiave",
  "etichetta": "Etichetta",
  "opzioni_csv": "Opzioni (separate da virgola)",
  "obbligatorio": "Obbligatorio",
  "mostra_per_modalita": "Mostra per modalità (vuoto = tutte)",
  "calcolo_prezzo": "Calcolo prezzo…",
  "calcola_prezzo": "Calcola prezzo",
  "prezzo_calcolato": "Prezzo calcolato dal gestore",
  "usa_prezzo_calcolato": "Usa prezzo calcolato",
  "percorso_incompleto": "Completa la tratta per calcolare il prezzo",
  "config_prenotazioni": "Config prenotazioni",
  "stazione_partenza": "Stazione partenza",
  "stazione_arrivo": "Stazione arrivo",
  "numero_treno": "Numero treno",
  "percorso": "Percorso",
  "modifica_servizio": "Modifica servizio",
  "servizi_offerti": "Servizi offerti",
  "nessun_dettaglio": "Nessun dettaglio disponibile",
  "data_primo_servizio": "Data primo servizio",
  "fermo_auto_minuti": "Fermo auto (minuti)",
  "item_type": "Tipo collo",
  "item_type_documents": "Documenti",
  "item_type_parcel": "Pacco",
  "item_type_medical_supplies": "Presidi medici",
  "item_type_luggage": "Bagagli",
  "item_type_other": "Altro",
  "weight_kg": "Peso (kg)",
  "dimensions": "Dimensioni (LxPxA cm)",
  "fragile": "Fragile",
  "stretcher": "Barella",
  "wheelchair_required": "Sedia a rotelle necessaria",
  "oxygen_required": "Ossigeno",
  "medical_escort": "Accompagnamento sanitario",
  "medical_escort_none": "Nessuno",
  "medical_escort_nurse": "Infermiere",
  "medical_escort_doctor": "Medico",
  "patient_condition": "Condizioni del paziente",
  "duration_minutes": "Durata (minuti)",
  "assistance_type": "Tipo assistenza",
  "assistance_type_companionship": "Compagnia",
  "assistance_type_errands": "Commissioni",
  "assistance_type_hospital": "Assistenza ospedaliera",
  "assistance_type_other": "Altro",
  "carriage": "Carrozza",
  "seat": "Posto",
  "prm_assistance": "Assistenza PRM (Sala Blu)",
  "campo_obbligatorio": "Campo obbligatorio",
  "data_obbligatoria": "Data obbligatoria.",
  "stazioni_obbligatorie": "Stazioni di partenza/arrivo obbligatorie.",
  "indirizzo_obbligatorio": "Indirizzo obbligatorio.",
  "indirizzi_obbligatori": "Indirizzi di partenza/arrivo obbligatori.",
  "tempo": "Tempo",
  "booking_status_draft": "Bozza",
  "booking_status_confirmed": "Confermata",
  "booking_status_in_progress": "In corso",
  "booking_status_completed": "Completata",
  "booking_status_partial": "Parziale",
  "booking_status_cancelled": "Annullata",
  "NON": "NON",
  "fermo_auto": "Fermo auto",
  "note": "Note",
  "sicuro_annullare": "Sei sicuro di voler annullare il viaggio?",
  "modifica_non_reversibile": "La modifica non è reversibile e arriverà l'email di annullamento al cliente.",
  "no_annulla": "No, annulla",
  "annulla_selezionati": "Annulla selezionati",
  "si_elimina": "Sì, elimina",
  "calendario": "Calendario",
  "pianificazione": "Pianificazione",
  "filtra_autista": "Filtra per autista",
  "agg_viaggio": "Aggiungi viaggio",
  "colori_descr": "I colori aziendali appaiono solo sui viaggi prenotati dal cliente in dashboard B2B",
  "data_ora": "Data e Ora",
  "chiudi": "Chiudi",
  "copia": "Copia",
  "modifica": "Modifica",
  "elimina_": "Elimina",
  "canale": "Canale",
  "autonomo": "Autonomo, con liberatoria",
  "nascondi_assegnati": "Nascondi viaggi assegnati",
  "nascondi_pianificati": "Nascondi pianificati",
  "nascondi_disponibili": "Nascondi turni disp.",
  "viaggi_in_corso": "Viaggi in corso",
  "raggruppa": "Raggruppa",
  "viaggi_nei_prossimi_giorni": "Viaggi nei prossimi giorni",
  "nessun_viaggio_previsto": "Nessun viaggio previsto",
  "scegli_colore": "Scegli un colore",
  "stato_pagamento": "Stato pagam.",
  "ci_sono": "Ci sono",
  "richieste_di_soccorso": "richieste di soccorso!",
  "logout": "Logout",
  "gestionale": "Gestionale",
  "dashboard": "Dashboard",
  "analytics": "Analytics",
  "mezzi": "Mezzi",
  "clienti": "Clienti",
  "check_mezzo": "Check sul mezzo",
  "contratti": "Contratti",
  "imposta": "Imposta",
  "numero_fattura": "Numero fattura",
  "autisti": "Autisti",
  "soccorso": "soccorso",
  "veicolo_associato": "Veicolo associato",
  "contratti_attivi": "Contratti attivi",
  "aggiungi_contratto": "Aggiungi contratto",
  "nessun_contratto_attivo": "Nessun contratto attivo",
  "cod_contratto_obbligatorio": "Il codice contratto è obbligatorio",
  "prezzo_contratto_obbligatorio": "Il prezzo del contratto è obbligatorio",
  "cliente_contratto_obbligatorio": "Il cliente del contratto è obbligatorio",
  "data_contratto_obbligatorio": "La data di fine contratto è obbligatoria",
  "inserimento_contratto": "Inserimento contratto",
  "aggiornamento_contratto": "Aggiornamento contratto",
  "cap_non_valido": "CAP non valido",
  "nome_non_valido": "Nome non valido",
  "cognome_non_valido": "Cognome non valido",
  "password_non_valida": "Password non valida",
  "email_non_valida": "Formato email non valido",
  "nome_passeggero_mancante": "Nome passeggero mancante.",
  "cognome_passeggero_mancante": "Cognome passeggero mancante.",
  "indirizzo_partenza_non_valido": "Indirizzo di partenza non valido.",
  "indirizzo_arrivo_non_valido": "Indirizzo di arrivo non valido.",
  "orario_presa_formato": "L'orario di presa deve essere nel formato HH:mm.",
  "data_viaggio_non_presente": "Data viaggio non presente",
  "indirizzo_di_partenza_non_valido": "Indirizzo di partenza non valido",
  "indirizzo_di_arrivo_non_valido": "Indirizzo di arrivo non valido",
  "prezzo_non_valido": "Prezzo non valido",
  "riepilogo_error": "Per inviare il riepilogo all'utente occorre indicare il suo indirizzo email.",
  "pagato": "pagato",
  "cliente_ordine": "Il cliente ha effettuato l'ordine il: ",
  "ordine_inserito": "Ordine inserito: ",
  "cliente_richiede": "Il cliente richiede il servizio per il: ",
  "data_servizio": "Data servizio: ",
  "vuoi_cancellare_ordine": "Vuoi cancellare l'ordine?",
  "inserisci_email": "Inserisci un indirizzo email",
  "errore_generico": "Errore generico. Riprovare più tardi",
  "email_inviata": "Ti abbiamo inviato un email con le istruzioni per cambiare la password",
  "sicuro_rimuovi_mezzo": "Sei sicuro di voler rimuovere il mezzo targato: ",
  "km_non_validi": "km non validi",
  "targa_non_valida": "Targa non valida",
  "data_revisione_non_valida": "Data revisione non valida",
  "data_omologazione_non_valida": "Data omologazione non valida",
  "data_assicurazione_non_valida": "Data assicurazione non valida",
  "telefono_non_valido": "Telefono non valido",
  "patente_non_valida": "Numero patente in formato non corretto (Necessari 10 caratteri)",
  "password_non_valida_char": "La password deve contenere almeno 8 caratteri",
  "tipo_file_errato": "Tipo file errato",
  "sicuro_annulla": "Sei sicuro di voler annullare l'ordine?",
  "italiano": "Italiano",
  "inglese": "Inglese",
  "proposta_ottimizzazione": "Proposta di ottimizzazione",
  "nessuna_ottimizzazione": "I viaggi sono già organizzati in maniera ottimale.",
  "conferma": "Conferma",
  "data_ricezione": "Data di ricezione",
  "gps_serial": "Seriale GPS",
  "data_ricezione_non_valida": "Data di ricezione non valida",
  "sicuro_rimuovi": "Confermi la cancellazione?",
  "sicuro_rimuovi_permanente": "Confermi la cancellazione? Una volta cancellato non potrà più essere ripristinato.",
  "viaggi_effettuati": "Viaggi effettuati",
  "nessun_autista": "Nessun Autista",
  "carrozzina": "Con Carrozzina",
  "no_carrozzina": "Senza Carrozzina",
  "persone": "persone",
  "accompagnatori": "Accompagnatori",
  "invia": "Invia",
  "sel-autista": "Seleziona Autista",
  "segna_presenza": "Segna come presente",
  "gestisci_assenze": "Gestisci Assenze",
  "nessun_assenza": "Nessun Assenza",
  "esporta_assenze": "Esporta Report Assenze",
  "vicini": "Autisti vicini",
  "timeline": "Timeline",
  "allettati": "Allettati",
  "ora_ritorno": "Orario di Ritorno",
  "vuoi_cancellare_anche_andata": "A questo viaggio è associato un ritorno, annullare anche il ritorno?",
  "vuoi_cancellare_anche_ritorno": "Questo viaggio è un ritorno, annullare anche l'andata?",
  "modifica_andata": "Modifica anche andata",
  "modifica_ritorno": "Modifica anche ritorno",
  "totale_transato_singoli": "Transato viaggi singoli",
  "totale_viaggi_singoli": "Corse viaggi singoli",
  "totale_transato_cd": "Transato gruppi",
  "totale_viaggi_cd": "Corse viaggi gruppi",
  "a_partire_da": "Dal: ",
  "giorno_visualizzato": "Giorno visualizzato: ",
  "impersona_utenti": "Impersona Utenti",
  "custom_token": "Custom Token",
  "ruolo": "Ruolo",
  "impersona": "Impersona",
  "id": "ID",
  "company": "Azienda",
  "aggiungi_utente_gestore": "Aggiungi Utente Gestore",
  "utenti_gestori": "Utenti Gestori",
  "name": "Nome",
  "opzioni_gestore": "Opzioni Gestore",
  "visualizza_inseriti": "Visualizza viaggi non assegnati",
  "opzioni_admin": "Opzioni per Admin",
  "visualizza_in_timeline": "Visualizza in Timeline",
  "visualizza_in_calendario": "Visualizza in Calendario",
  "visualizza_in_lista": "Visualizza in Lista",
  "mostra_autisti": "Mostra Autisti",
  "nascondi_altri_gestori": "Nascondi altri Gestori",
  "in_carrozzina": "Utente in Carrozzina",
  "code": "Codice",
  "color": "Colore",
  "companies": "Aziende",
  "aziende_aggregate": "Aziende aggregate",
  "aziende_aggregate_hint": "Le aziende selezionate vengono aggregate: i loro campi personalizzati e dati confluiscono in questa azienda multi.",
  "seleziona_aziende": "Seleziona aziende...",
  "aggiungi-company": "Aggiungi Azienda",
  "aggiungi_company": "Aggiungi Azienda",
  "elenco_companies": "Elenco Aziende",
  "dati_company": "Dati Azienda",
  "label": "Nome Visualizzato",
  "address": "Indirizzo",
  "orario_ingresso": "Orario di Ingresso",
  "orario_uscita": "Orario di Uscita",
  "dati_fatturazione": "Dati di Fatturazione",
  "codice_fiscale": "Codice Fiscale",
  "codice_sdi": "Codice SDI",
  "denominazione": "Denominazione",
  "p_iva": "P. IVA",
  "sede_legale": "Sede Legale",
  "cap": "CAP",
  "civico": "Civico",
  "comune": "Comune",
  "nazione": "Nazione",
  "provincia": "Provincia",
  "mattina": "Mattina",
  "pomeriggio": "Pomeriggio",
  "lunedi": "Lunedì",
  "martedi": "Martedì",
  "mercoledi": "Mercoledì",
  "giovedi": "Giovedì",
  "venerdi": "Venerdì",
  "gruppo": "Gruppo",
  "ottimizza_viaggi": "Ottimizza Giri",
  "giorno": "Giorno",
  "daytime": "Momento della Giornata",
  "viaggi": "Viaggi",
  "seleziona_giorno": "Seleziona Giorno",
  "seleziona_daytime": "Seleziona Momento della Giornata",
  "ottimizza": "Ottimizza",
  "annulla": "Annulla",
  "orario_minimo": "Orario di Partenza Minimo",
  "report_assenze": "Esporta Report Assenze Mensile",
  "aggiungi_utente": "Aggiungi Utente",
  "seleziona_mese": "Seleziona Mese",
  "seleziona_anno": "Seleziona Anno",
  "mese": "Mese",
  "anno": "Anno",
  "preferenza_orario": "Preferenza Orario",
  "aggiungi_in_gruppo": "Aggiungi in un Gruppo",
  "aggiungi_ricalcola": "Aggiungi e Ricalcola Percorsi",
  "vecchio_orario": "Vecchio Orario",
  "nuovo_orario": "Nuovo Orario",
  "tutto_il_giorno": "Tutta la Giornata",
  "tutti_i_giorni": "Tutti i Giorni",
  "gestione_viaggi_azienda": "Gestione Viaggi Azienda",
  "ricerca": "Cerca",
  "pendings": "Richieste in Attesa",
  "email_utenti_cd": "Invia Email per Utenti",
  "email_giri_cd": "Invia Email per Pulmini",
  "email_inviata_cd": "Email Inviata",
  "nome_operatore": "Nome Operatore",
  "num_orders": "Numero Prenotazioni",
  "total_price": "Fatturato",
  "fatturato": "Fatturato",
  "classifica_operatori": "Classifica Operatori",
  "gennaio": "Gennaio",
  "febbraio": "Febbraio",
  "marzo": "Marzo",
  "aprile": "Aprile",
  "maggio": "Maggio",
  "giugno": "Giugno",
  "luglio": "Luglio",
  "agosto": "Agosto",
  "settembre": "Settembre",
  "ottobre": "Ottobre",
  "novembre": "Novembre",
  "dicembre": "Dicembre",
  "users": "Utenti",
  "tutte_le_aziende": "Tutte le Aziende",
  "fatturato_medio_per_prenotazione": "Fatturato medio per Prenotazione",
  "home": "Home",
  "operators": "Operatori",
  "count_orders": "Numero Prenotazioni",
  "new_users": "Nuovi Utenti",
  "inbound_calls": "Chiamate in Entrata",
  "grouping_criteria": "Fonte",
  "management_site": "Gestionale",
  "grouped_rides": "Viaggi di Gruppo",
  "other_managers": "Altri Gestori",
  "b2b_dashboard": "Dashboard B2B",
  "website": "Sito Web",
  "nessuna_fonte": "Nessuna Fonte",
  "densita_toolbar": "Densità",
  "private_users": "Utenti Privati",
  "other_companies_users": "Utenti di Altre Aziende",
  "managers": "Gestori",
  "answered_calls": "Chiamate con Risposta",
  "contractStatus": "Stato Contratto",
  "contractCode": "Codice Contratto",
  "contractEndDate": "Data Fine Contratto",
  "contractStartDate": "Data Inizio Contratto",
  "contractPrice": "Prezzo Contratto",
  "actions": "Azioni",
  "type": "Tipo",
  "required": "Obbligatorio",
  "read_only": "Solo Lettura",
  "size": "Dimensione",
  "class_type": "Tipologia",
  "modifica_company": "Modifica Azienda",
  "add_field": "Aggiungi Campo",
  "field_name": "Nome Campo",
  "field_type": "Tipo Campo",
  "field_label": "Etichetta Campo",
  "field_required": "Obbligatorio",
  "field_read_only": "Solo Lettura",
  "field_size": "Dimensione",
  "field_class_type": "Tipologia",
  "customFields": "Campi Personalizzati Viaggio",
  "noFields": "Nessun Campo Personalizzato",
  "addField": "Aggiungi Campo",
  "types": "Tipi",
  "prezzo_utente": "Prezzo Utente",
  "cdi": "Centro Diurno",
  "vans": "Veicoli Assegnati",
  "yes": "Si",
  "no": "No",
  "active": "Attivo",
  "contracts": "Contratti",
  "noContracts": "Nessun Contratto",
  "field_name_placeholder": "Inserisci Nome Campo",
  "field_type_placeholder": "Scegli Tipo Campo",
  "field_label_placeholder": "Inserisci Etichetta Campo",
  "field_size_placeholder": "Inserisci Dimensione Campo",
  "field_class_type_placeholder": "Scegli Tipologia Campo",
  "inactive": "Inattivo",
  "multiple": "Opzioni Multiple",
  "hidden": "Nascosto",
  "edit_field": "Modifica Campo",
  "delete_field": "Elimina Campo",
  "dependencies": "Dipendenze",
  "options_for_select": "Opzioni della Select",
  "default_value": "Valore Predefinito",
  "num_prospect": "Num. Prospect",
  "nessun_operatore": "Nessun Operatore",
  "seleziona_centro_diurno": "Seleziona Centro Diurno",
  "momento_della_giornata": "Momento della Giornata",
  "vuoi_attivare_ordine": "Vuoi attivare l'ordine?",
  "attiva_ordine": "Attiva l'ordine",
  "centri_diurni": "Car Pooling",
  "seleziona_tipo": "Seleziona Tipo",
  "add-trips": "Aggiungi Viaggi",
  "reset_filtri": "Resetta Filtri",
  "add": "Aggiungi",
  "seleziona_viaggi_da_aggiungere": "Seleziona Viaggi da Aggiungere",
  "showCount": "N° Corse",
  "showRevenue": "Fatturato",
  "showActual": "Actual",
  "showForecast": "Forecast",
  "showGroupCount": "Numero di Gruppi",
  "editMode": "Modalità di Modifica",
  "editForecast": "Mod. Forecast",
  "editActual": "Mod. Actual",
  "none": "Off",
  "new_Company": " Azienda Forecast",
  "new_forecast": "Nuovo Forecast",
  "company_name": "Nome Azienda",
  "type_forecast": "Tipo Forecast",
  "count": "N° Corse",
  "revenue": "Fatturato",
  "january": "Gennaio",
  "february": "Febbraio",
  "march": "Marzo",
  "april": "Aprile",
  "may": "Maggio",
  "june": "Giugno",
  "july": "Luglio",
  "august": "Agosto",
  "september": "Settembre",
  "october": "Ottobre",
  "november": "Novembre",
  "december": "Dicembre",
  "analytics_details": "Dettaglio Analytics",
  "total_90": "Totale Senza IVA",
  "total_10": "IVA (10%)",
  "avg": "Costo Medio Corsa",
  "total": "Totale",
  "total_carried_persons": "Totale Persone Trasportate",
  "avg_carried_persons": "Media Persone Trasportate",
  "total_car_pooled": "Totale Corse In Car Pooling",
  "total_not_car_pooled": "Totale Corse Non In Car Pooling",
  "avg-price": "Costo Medio Corsa",
  "viewMode": "Modalità di Visualizzazione",
  "report_vehicles": "Report Veicoli",
  "custom_interval": "Intervallo Personalizzato",
  "select_interval": "Seleziona Intervallo",
  "seleziona_mezzo": "Seleziona Mezzo",
  "ricarica": "Ricarica",
  "vehicles": "Veicoli",
  "mezzo": "Mezzo",
  "inizio": "Inizio",
  "fine": "Fine",
  "durataGuida": "Durata Guida",
  "tempoFermo": "Tempo Fermo",
  "durataGuida_s": "Durata Guida",
  "tempoFermo_s": "Tempo Fermo",
  "showDailyTrips": "Pianificati",
  "other": "Altro",
  "distanza_viaggio": "Distanza Viaggio",
  "veicolo": "Veicolo",
  "minivan": "Minivan",
  "available": "Disponibile",
  "pause": "Pausa",
  "extra": "Straordinario",
  "vacation": "Ferie",
  "sick": "Malattia",
  "disponibile": "Disponibile",
  "non disponibile": "Non Disponibile",
  "malattia": "Malattia",
  "straordinario": "Straordinario",
  "fleet": "Flotta",
  "hub": "Hub",
  "ferie": "Ferie",
  "pausa": "Pausa",
  "default-targa": "Non Assegnata",
  "nuovo-turno": "Nuovo Turno",
  "assegna-veicolo ": "Assegna Veicolo ",
  "orari_autisti": "Orari Autisti",
  "nuovo_viaggio": "Nuovo Viaggio",
  "nuova_ambulanza": "Nuova Ambulanza",
  "nuova_assistenza": "Nuova Assistenza",
  "nuovo_treno": "Nuovo Treno",
  "nuovo_trasporto_oggetti": "Nuovo Trasporto Oggetti",
  "nuovo_turno": "Nuovo Turno",
  "nuovo_evento": "Nuovo Evento",
  "luogo": "Luogo",
  "si": "Sì",
  "oggi": "Oggi",
  "abilita_modifica_shift": "Modifica Turni",
  "ordini_altri_gestori": "{{count}} ordini in altri gestori",
  "timeline_saturation": "Saturazione",
  "timeline_saturation_aria": "Saturazione {{pct}}%: {{occupied}} occupate su {{shift}} di turno",
  "timeline_saturation_no_shift": "Nessun turno",
  "timeline_occupied_time": "Tempo occupato",
  "timeline_extra_time": "di cui extra",
  "timeline_legend": "Legenda modalità",
  "timeline_mode_filter_reset": "Tutte le modalità",
  "giorno_precedente": "Giorno precedente",
  "ora_precedente": "Ora precedente",
  "ora_successiva": "Ora successiva",
  "giorno_successivo": "Giorno successivo",
  "visualizza_analisi": "Visualizza analisi",
  "duration_ride": "Durata giro",
  "timeline_color_legend": "Legenda colori",
  "timeline_deadhead": "Percorrenza",
  "timeline_event_time": "Eventi",
  "filtri": "Filtri",
  "timeline_subtitle": "Dispatch e programmazione giornaliera",
  "vehicle_assignment": "Assegnazione mezzo",
  "timeline_show_past_travel": "Percorrenze nel passato",
  "timeline_show_delays": "Mostra ritardi e anticipi",
  "color_default": "Standard",
  "color_planned": "Pianificato",
  "color_planned_override": "Pianificato con eccezione",
  "color_planned_op2": "Pianificato — 2° operatore",
  "color_app": "Prenotazione app",
  "color_assistance": "Assistenza",
  "color_cancelled": "Annullato",
  "color_refused": "Rifiutato",
  "color_absent": "Assente",
  "color_delay": "Ritardo (partenza o arrivo)",
  "color_early": "Anticipo (partenza o arrivo)",
  "color_company_note": "Colore azienda/commessa quando presente",
  "real_departure": "Partenza reale",
  "real_arrival": "Fine reale",
  "scheduled_time": "Orario programmato",
  "real_time": "Orario reale",
  "estimated_time": "Orario stimato",
  "arrivo_previsto": "Arrivo previsto",
  "estimated_end": "Fine stimata",
  "delay": "Ritardo",
  "early": "Anticipo",
  "seat_occupancy": "Occupazione posti",
  "over_capacity": "Capacità superata",
  "wheelchair_over_capacity": "Posti carrozzina superati",
  "no_vehicle_assigned": "Nessun mezzo assegnato",
  "requires_ambulance": "Richiede ambulanza",
  "senza_hub": "Senza hub",
  "filtra_hub": "Filtra per hub",
  "vai_al_giorno": "Vai al giorno",
  "manager-unknown": "Gestore sconosciuto",
  "dettagli_viaggio": "Dettagli Viaggio",
  "da_incassare": "Da Incassare",
  "showTraffic": "Mostra Traffico",
  "passeggeri": "Passeggeri",
  "visualizza gruppo": "Visualizza Gruppo",
  "distance": "Distanza",
  "duration": "Durata",
  "showStops ▼": "Mostra Fermate ▼",
  "hideStops ▲": "Nascondi Fermate ▲",
  "from": "Da",
  "to": "A",
  "elenco_viaggi": "Elenco Viaggi",
  "Filtra Per Data": "Filtra Per Data",
  "Totale Corse": "Totale Corse",
  "Totale Fatturato": "Totale Fatturato",
  "Minuti Totali Fermo Auto": "Minuti Totali Fermo Auto",
  "Fatturato Fermo Auto": "Fatturato Fermo Auto",
  "capacità": "Capacità",
  "capacità_carica": "Capacità Carica",
  "hub_aziendali": "Hub Aziendali",
  "aggiungi_hub": "Aggiungi Hub",
  "elenco_hub": "Elenco Hub",
  "nessun_hub": "Nessun Hub",
  "hub_aziendale": "Hub Aziendale",
  "modifica_hub": "Modifica Hub",
  "dati_hub": "Dati Hub",
  "informazioni_base": "Informazioni Base",
  "assegnazione_gestore": "Assegnazione Gestore",
  "documenti": "Documenti",
  "carica": "Carica",
  "carica_altri": "Carica altri",
  "modifica_autista": "Modifica Autista",
  "elimina_autista": "Elimina Autista",
  "vista_autista": "Vista autista (live)",
  "account": "Account",
  "dati_autista": "Dati Autista",
  "seleziona_gestore": "Seleziona Gestore",
  "dati_contatto": "Dati di Contatto",
  "modello": "Modello",
  "marca": "Marca",
  "km_omologazione": "Km di Omologazione",
  "nessun_mezzo": "Nessun Mezzo",
  "tipo": "Tipo",
  "posti": "Posti",
  "posti_short": "posti",
  "posti_carrozzina_short": "carrozzina",
  "tipologia_non_assegnata": "Tipologia non assegnata",
  "posti_carrozzina": "Posti Carrozzina",
  "modifica_mezzo": "Modifica Mezzo",
  "assegnazioni": "Assegnazioni",
  "assegnato_a": "Assegnato a",
  "assegnati_oggi": "Assegnati oggi",
  "assegnazione_tutte": "Assegnati e liberi",
  "mezzo_libero": "Libero",
  "mezzi_liberi": "Liberi",
  "tracciamento_gps": "Tracciamento GPS",
  "percorsi": "Percorsi",
  "percorsi_del_mese": "Percorsi del mese",
  "km_totali": "Km totali",
  "nessun_percorso": "Nessun percorso nel periodo",
  "gps_non_configurato": "Integrazione GPS non configurata",
  "autisti_fulltime": "Autisti Full-Time",
  "autisti_parttime": "Autisti Part-Time",
  "autisti_fte": "Autisti FTE",
  "accompagnatori_fte": "Accompagnatori FTE",
  "totale_fte": "Totale FTE",
  "accompagnatore": "Accompagnatore",
  "vedi_dettaglio_autisti": "Vedi chi è compreso nel conteggio",
  "dettaglio_autisti_disponibili": "Dettaglio autisti disponibili",
  "ore_non_impostate": "ore non impostate",
  "fte_stimato_chip": "FTE stimato dal contratto",
  "fte_stimati_dettaglio_nota": "su questo elenco non hanno ore contrattuali utilizzabili: valgono 1 FTE, 0,5 se part-time.",
  "nessun_autista_in_questo_gruppo": "Nessun autista disponibile in questo gruppo con i filtri attuali.",
  "fte_stimati_nota": "senza ore contrattuali utilizzabili: contati 1 (0,5 se part-time)",
  "autisti_disponibili_nota_filtri": "Conteggio su tutti gli autisti visibili: premi Applica per restringerlo a gestori e commesse.",
  "gps_attivita": "Attività",
  "gps_tragitto_n": "Tragitto {{n}}",
  "gps_mezzo_fermo": "Mezzo fermo",
  "gps_fine_attivita": "Fine attività",
  "vedi_percorso": "Vedi percorso",
  "percorso_sulla_mappa": "Sulla mappa",
  "mostra_tutto_il_percorso": "Mostra tutto il percorso",
  "gps_vedi_posizione": "Vedi posizione",
  "gps_nessuna_attivita": "Nessuna attività nel periodo",
  "gps_in_movimento": "In movimento",
  "gps_soste": "Soste",
  "gps_non_configurato_desc": "Inserisci il seriale GPS del device sul mezzo, oppure imposta il provider GPS = SafeFleet sul gestore del mezzo.",
  "safefleet_id_mancante": "ID veicolo SafeFleet mancante",
  "safefleet_id_mancante_desc": "Inserisci il seriale GPS del device sul mezzo, oppure l'ID veicolo SafeFleet nei dati amministrativi del mezzo.",
  "safefleet_vehicle_id": "ID veicolo SafeFleet",
  "posti_sedere": "Posti",
  "seats": "Posti a Sedere",
  "wheelchair_filling": "Posti Occupati da Una Carrozzina",
  "max_wheelchair_seats": "Max Posti per Carrozzina",
  "date_tecniche": "Data Tecniche",
  "centerVehicle": "Centra Veicolo",
  "gestione_turni_autisti": "Gestione turni autisti",
  "filtra_per_gestore": "Filtra per gestore",
  "nome_o_cognome": "Nome o cognome",
  "vehicle_cleaning": "Pulizia veicolo",
  "vehicle_charge": "Ricarica veicolo",
  "vehicle_maintenance": "Manutenzione veicolo",
  "course": "Corso",
  "andata_a_vuoto": "Andata a vuoto",
  "ritorno_a_vuoto": "Ritorno a vuoto",
  "vuoto_collegato_hint": "Viaggio lungo: aggiunge lo spostamento a vuoto dell'autista, collegato al servizio. Serve un autista assegnato.",
  "ar_non_disponibile": "Andata e ritorno non disponibile con fermo auto o con andata/ritorno a vuoto.",
  "ritorno_dopo_fermo": "Ritorno dopo fermo auto (x2)",
  "viaggio_a_vuoto": "Viaggio a vuoto",
  "autista_non_valido": "Seleziona un autista per il viaggio a vuoto",
  "informazioni_evento": "Informazioni evento",
  "tipo_evento": "Tipo evento",
  "seleziona_data_ora": "Seleziona data e ora",
  "durata": "Durata (min)",
  "dati_trasporto": "Dati trasporto",
  "distanza_km": "Distanza (km)",
  "dati_conducente_veicolo": "Dati conducente e veicolo",
  "seleziona_autista": "Seleziona autista",
  "seleziona_veicolo": "Seleziona veicolo",
  "aggiungi_note": "Aggiungi note",
  "dati_evento": "Dati evento",
  "dettagli_evento": "Dettagli evento",
  "durata_evento": "Durata evento",
  "cancella": "Cancella",
  "gestito_da": "Gestito da",
  "aggiorna": "Aggiorna",
  "invia_riepilogo": "Invia Riepilogo",
  "crea_fattura": "Crea Fattura",
  "stationed": "In Presidio",
  "optimize": "Ottimizza",
  "tappa": "Tappa",
  "ETA": "Tempo stimato di arrivo",
  "status": "Stato",
  "aggiungi_al_giro": "Aggiungi al giro",
  "orario_inizio": "Orario di inizio",
  "ottimizza_percorso": "Ottimizza il percorso",
  "viewOptimizedStops": "Visualizza fermate ottimizzate",
  "riassegna": "Riassegna",
  "fake": "Fake",
  "backup": "Backup",
  "companion": "Accompagnatore",
  "commessa": "Commessa/Bando",
  "nessun_viaggio_programmato": "Nessun viaggio programmato",
  "caricamento_timeline": "Caricamento timeline...",
  "nuova_attivita": "Nuova attività",
  "turni": "Turni",
  "orari": "Orari",
  "assegna_veicolo": "Assegna veicolo",
  "altro": "Altro",
  "auto": "Auto",
  "bus": "Autobus",
  "van": "Pulmino",
  "ambulance": "Ambulanza",
  "unavailable": "Non Disponibile",
  "maintenance": "In Manutenzione",
  "lost": "Smarrito",
  "wait_for_documents": "In Attesa di Documenti",
  "documenti_caricati_successo": "Documenti caricati con successo",
  "errore_upload": "Errore durante il caricamento",
  "documento_eliminato_successo": "Documento eliminato con successo",
  "errore_eliminazione": "Errore durante l'eliminazione",
  "documento": "Documento",
  "documenti_esistenti": "Documenti esistenti",
  "ricevuta": "Ricevuta",
  "assegna": "Assegna",
  "assegnazione": "Assegnazione",
  "elenco_assegnazioni": "Elenco assegnazioni",
  "Ins.": "Ins.",
  "Serv.": "Serv.",
  "in attesa": "In attesa",
  "pending": "In attesa",
  "tratta": "Tratta",
  "prezzo_corsa": "Prezzo corsa",
  "prezzo_totale": "Prezzo totale",
  "imponibile": "Imponibile",
  "totale_imponibile_corse": "Imponibile totale",
  "pagamento": "Pagamento",
  "stato_fatturazione": "Stato fatt.",
  "b2c": "B2C",
  "non incassare": "Non incassare",
  "incassato": "Incassato",
  "contestato": "Contestato",
  "versato": "Versato",
  "rimborsato": "Rimborsato",
  "fallito": "Fallito",
  "parziale": "Parziale",
  "storno": "Storno",
  "non fatturato": "Da non fatturare",
  "errore": "Errore",
  "b2b": "B2B",
  "tipo_pagamento": "Tipo di pagamento",
  "contanti": "Contanti",
  "carta": "Carta",
  "fnmpay": "FNM Pay",
  "paypal": "PayPal",
  "bonifico": "Bonifico",
  "consuntivo": "Consuntivo",
  "not_invoiced": "Da non fatturare",
  "invoiced": "Fatturato",
  "partial": "Parziale",
  "error": "Errore",
  "totale_prezzo_corse": "Totale Prezzo Corse",
  "prezzo_totale_fermo_auto": "Totale Fermo Auto",
  "metodo_pagamento": "Metodo di pagamento",
  "minuti_totali_fermo_auto": "Minuti Fermo Auto",
  "totale_corse": "Totale Corse",
  "non specificato": "Non specificato",
  "fattura": "Fattura",
  "domicilio_fiscale": "Domicilio fiscale",
  "dati_destinatario_fattura": "Dati destinatario fattura",
  "Staz": "Presidio",
  "Pausa": "Pausa",
  "attivo": "Attivo",
  "inattivo": "Inattivo",
  "disabilitato": "Disabilitato",
  "cancellato": "Cancellato",
  "sconosciuto": "Sconosciuto",
  "viaggi_singoli": "Viaggi singoli",
  "pianificatore": "Pianificatore",
  "utenti": "Utenti",
  "modifica_cliente": "Modifica cliente",
  "nuovo_cliente": "Nuovo cliente",
  "note_operative": "Note operative",
  "operative_notes": "Note operative",
  "consensi": "Consensi",
  "privacy": "Privacy",
  "accepted_date": "Data di accettazione",
  "marketing": "Marketing",
  "note_interne": "Note interne",
  "comunicazioni": "Comunicazioni",
  "telefonate": "Telefonate",
  "nessun_elemento": "Nessun elemento",
  "nuova_email": "Nuova email",
  "registra_chiamata": "Registra chiamata",
  "indirizzi": "Indirizzi",
  "nuovo_indirizzo": "Nuovo indirizzo",
  "barriere_architettoniche": "Barriere architettoniche",
  "fatture": "Fatture",
  "contabilita": "Contabilità",
  "tributi": "Tributi",
  "pianificati": "Pianificati",
  "stato_e_sicurezza": "Stato e sicurezza",
  "mobility": "Mobilità",
  "companions": "Accompagnatori",
  "anagrafica_e_contatti": "Anagrafica e contatti",
  "telefono_2": "Telefono 2",
  "naz": "Naz.",
  "prov": "Prov.",
  "ambulatory": "Deambulante",
  "wheelchair": "Su sedia a rotelle",
  "bedridden": "Allettato",
  "lunedì": "Lunedì",
  "martedì": "Martedì",
  "mercoledì": "Mercoledì",
  "giovedì": "Giovedì",
  "venerdì": "Venerdì",
  "sabato": "Sabato",
  "domenica": "Domenica",
  "tipo_viaggio": "Tipo di viaggio",
  "barr_arch": "Barriere architettoniche",
  "barr_arch_part": "Barriere architettoniche (partenza)",
  "barr_arch_arr": "Barriere architettoniche (arrivo)",
  "tutti": "Tutti",
  "senza_commessa": "Senza commessa",
  "accompagnatore_richiesto": "Accompagnatore richiesto",
  "in_salita": "In salita",
  "in_discesa": "In discesa",
  "per_tutta_la_durata": "Per tutta la durata",
  "require_wheelchair": "Richiede sedia a rotelle",
  "require_baby_seat": "Richiedi seggiolino neonato",
  "ritorno": "Ritorno",
  "assistenza_note": "Assistenza & Note",
  "booking_reference": "Prenotazione",
  "urbano": "Urbano",
  "extra_urbano": "Extra-Urbano",
  "nessun_campo_personalizzato": "Nessun campo personalizzato",
  "anteprima": "Anteprima",
  "nessun_viaggio_da_mostrare_attiva_almeno_un_giorno_e_imposta_orari": "Nessun viaggio da mostrare: attiva almeno un giorno e imposta gli orari",
  "seleziona_metodo": "Seleziona metodo",
  "seleziona_stato": "Seleziona stato",
  "subtotale_calcolato": "Subtotale calcolato",
  "totale_con_fermo_auto": "Totale con fermo auto",
  "stato_fattura": "Stato fattura",
  "seleziona_stato_fattura": "Seleziona stato fattura",
  "nessuna_fattura": "Nessuna fattura",
  "Pianificatore": "Pianificatore",
  "planner.subtitle": "Pianifica e gestisci i viaggi",
  "calcola prezzo": "Calcola prezzo",
  "calcola_distanza": "Calcola distanza",
  "save": "Salva",
  "unknownUser": "Utente sconosciuto",
  "newUser": "Nuovo utente",
  "removeUser": "Rimuovi utente",
  "settimana_tipo": "Settimana tipo",
  "attiva_lun_ven": "Attiva lun–ven",
  "ora_andata": "Ora andata",
  "selectExistingUser": "Seleziona utente esistente",
  "azioni_copia": "Azioni di copia",
  "copia_da_partenza": "Copia da partenza",
  "copia_da_arrivo": "Copia da arrivo",
  "cdi_planning": "Pianificazione CDI",
  "pianificati_singoli": "Pianificati singoli",
  "history_title": "Cronologia",
  "history_log": "Registro attività",
  "date": "Data",
  "action": "Azione",
  "done_by": "Eseguito da",
  "data_viaggio": "Data viaggio",
  "assignments": "Assegnazioni",
  "Base Price": "Prezzo base",
  "Tolls": "Pedaggi",
  "Extras": "Extra",
  "Double Operator": "Doppio operatore",
  "Discount": "Sconto",
  "secondo_operatore": "Secondo operatore",
  "secondo_operatore_salita": "Secondo operatore salita",
  "secondo_operatore_discesa": "Secondo operatore discesa",
  "secondo_operatore_arrivo": "Secondo operatore (arrivo)",
  "orario_ritorno": "Orario di ritorno",
  "copia_da_andata": "Copia dall'andata",
  "indirizzo_da_ritorno": "Indirizzo di partenza (ritorno)",
  "barr_arch_da_ritorno": "Barriere architettoniche (partenza – ritorno)",
  "indirizzo_a_ritorno": "Indirizzo di arrivo (ritorno)",
  "barr_arch_a_ritorno": "Barriere architettoniche (arrivo – ritorno)",
  "ward": "Reparto",
  "piano": "Piano",
  "stanza": "Stanza",
  "dimissione_firmata": "Dimissione firmata",
  "tipo_oggetti": "Tipo oggetti",
  "unspecified": "Non specificato",
  "attesa_incasso": "In attesa di incasso",
  "con_fermo_auto": "(Con fermo auto)",
  "card": "Carta",
  "cash": "Contanti",
  "fnm_pay": "FNMPay",
  "bank_transfer": "Bonifico bancario",
  "post_paid": "Consuntivo",
  "no_incasso": "Nessun incasso",
  "nessun_check": "Nessun controllo",
  "data_controllo_acqua": "Data del controllo dell’acqua",
  "data_controllo_olio": "Data del controllo dell’olio",
  "data_igienizzazione": "Data dell’igienizzazione",
  "Equipaggiamenti": "Dotazioni",
  "aggiungi equipaggiamento": "Aggiungi dotazione",
  "elenco_equipaggiamenti": "Elenco dotazioni",
  "equipments": "Dotazioni",
  "dotazioni": "Dotazioni",
  "dotazioni_assegnate": "Dotazioni assegnate",
  "dati_personali": "Dati personali",
  "data_nascita": "Data di nascita",
  "contatto_emergenza": "Contatto di emergenza",
  "telefono_emergenza": "Telefono di emergenza",
  "patente_da_corsi": "Il numero viene dalla patente registrata in Idoneità → Corsi e certificazioni.",
  "corsi_da_tab": "Corso 16 ore, KB e le altre abilitazioni si registrano in Idoneità → Corsi e certificazioni.",
  "fuel_type": "Alimentazione",
  "fuel_diesel": "Diesel",
  "fuel_petrol": "Benzina",
  "fuel_electric": "Elettrico",
  "fuel_hybrid": "Ibrido",
  "fuel_lpg": "GPL",
  "fuel_cng": "Metano",
  "vin": "Telaio (VIN)",
  "vin_non_valido": "Un numero di telaio ha 17 caratteri, senza I, O e Q.",
  "vehicle_without_oxygen": "Il servizio richiede ossigeno: il mezzo non ce l'ha",
  "hint_posti_da_tipologia": "Posti a sedere e posti carrozzina vengono dalla tipologia pulmino: per cambiarli modifica la tipologia.",
  "hint_posti_senza_tipologia": "Senza una tipologia pulmino valgono questi valori. I posti a sedere non contano l'autista.",
  "hint_wheelchair_filling": "Il terzo campo dice quanti posti a sedere occupa una carrozzina.",
  "tipologia_riallinea_mezzi": "Salvando, i posti di {{n}} mezzi con questa tipologia vengono aggiornati: {{plates}}.",
  "dotazioni_autista": "Dotazioni autista",
  "dotazioni_mezzo": "Dotazioni mezzo",
  "equipaggiamento_di_bordo": "Equipaggiamento di bordo",
  "dotazione": "Dotazione",
  "presente": "Presente",
  "nessuna_dotazione": "Nessuna dotazione assegnata",
  "aggiungi_dotazione": "Aggiungi dotazione",
  "permessi": "Permessi",
  "permessi_ztl": "Permessi e ZTL",
  "nessun_permesso": "Nessun permesso",
  "aggiungi_permesso": "Aggiungi permesso",
  "geofence": "Geofence",
  "seleziona_geofence": "Seleziona geofence",
  "costo_euro": "Costo (€)",
  "interventi_label": "Interventi",
  "nessun_dato": "Nessun dato",
  "costo_totale": "Costo totale",
  "costo_medio_mezzo": "Costo medio / mezzo",
  "costo_medio_km": "Costo medio / km",
  "costo_medio_intervento": "Costo medio / intervento",
  "costo_per_tipo_intervento": "Costo per tipo intervento",
  "costo_per_tipologia_mezzo": "Costo per tipologia mezzo",
  "costo_per_anno_immatricolazione": "Costo per anno immatricolazione",
  "KPI": "KPI",
  "attrezzature": "Attrezzature",
  "segnalazioni": "Segnalazioni",
  "Estintore": "Estintore",
  "Tessera carburante": "Tessera carburante",
  "Viacard": "Viacard",
  "GPS": "GPS",
  "Telefono": "Telefono",
  "SIM": "SIM",
  "Modifica tipo": "Modifica tipo",
  "Dati tipo": "Dati tipo",
  "Attrezzatura": "Attrezzatura",
  "Codice": "Codice",
  "Tipo": "Tipo",
  "Costo Orario": "Costo orario",
  "Dotazioni Veicolo": "Dotazioni veicolo",
  "Dati Personali": "Dati personali",
  "Corso16h": "Corso 16 ore",
  "seleziona equipaggiamenti": "Seleziona equipaggiamenti",
  "Taglia Maglia": "Taglia maglia",
  "seleziona taglia maglia": "Seleziona taglia maglia",
  "Taglia Pantaloni": "Taglia pantaloni",
  "seleziona taglia pantaloni": "Seleziona taglia pantaloni",
  "Part Time": "Part time",
  "Ore Lavorative": "Ore lavorative",
  "Aggiungi tipo": "Aggiungi tipo",
  "Attrezzature": "Attrezzature",
  "POS": "POS",
  "pocket_mask": "Pocket Mask",
  "cavo_22kw": "Cavo 22kW",
  "chiave_poli": "Chiave Policlinico",
  "scalino": "Scalino",
  "invia_email_pagamento": "Invia email di Pagamento",
  "update": "Aggiorna",
  "payment_email": {
    "title": "Email di pagamento",
    "send": "Invia",
    "to": "A",
    "from": "Da",
    "prezzo": "Prezzo"
  },
  "history": "Cronologia",
  "field": "Campo",
  "before": "Prima",
  "after": "Dopo",
  "avvisi": "Avvisi",
  "Equipments": "Dotazioni",
  "manage": "Gestisci",
  "caricamento": "Caricamento…",
  "kpi": "KPI",
  "chiama": "Chiama",
  "invia_email": "Invia email",
  "seleziona_contratto": "Seleziona contratto",
  "assenze": "Assenze",
  "Non Disponibile": "Non Disponibile",
  "Evento": "Evento",
  "mese_visualizzato": "Mese visualizzato",
  "cancella_cliente": "Cancella cliente",
  "solo_utenti_censiti": "Solo utenti censiti",
  "colore": "Colore",
  "apri": "Apri",
  "apri_ricevuta": "Apri ricevuta",
  "aggiunto": "Aggiunto",
  "aggiunto da": "Aggiunto da",
  "codice_fiscale_non_valido": "Codice fiscale non valido",
  "codice_fiscale_controllo_errato": "Codice fiscale errato: il carattere di controllo non torna (errore di battitura?)",
  "codice_fiscale_nomi_invertiti": "Nome e cognome sembrano invertiti rispetto al codice fiscale",
  "codice_fiscale_cognome_diverso": "Il codice fiscale non corrisponde al cognome (dal cognome risulta \"{{expected}}\")",
  "codice_fiscale_nome_diverso": "Il codice fiscale non corrisponde al nome (dal nome risulta \"{{expected}}\")",
  "inserisci_sigla_provincia": "Inserisci sigla provincia",
  "inserisci_sigla_nazione": "Inserisci sigla nazione",
  "compila_correttamente_tutti_i_campi": "Compila correttamente tutti i campi",
  "ore": "ore",
  "eventi": "eventi",
  "shifts": "Turni",
  "today": "Oggi",
  "inverti_indirizzi": "inverti indirizzi",
  "inverti_indirizzi_ritorno": "inverti indirizzi di ritorno",
  "base_price": "Prezzo base",
  "supplemento_passeggeri": "Supplemento passeggeri",
  "require_wheelchair_addition": "Rich. carrozzina",
  "dismissal_add": "Agg. Dimissione",
  "night_time": "Notturno",
  "double_operator": "Doppio operatore",
  "discount": "Sconto",
  "flyering": "Volantinaggio",
  "nessun_contratto_disponibile": "Nessun contratto disponibile per questa azienda.",
  "rich_carrozzina": "Rich. carrozzina",
  "agg_dimissione": "Agg. dimissione",
  "weekend": "Weekend",
  "notturno": "Notturno",
  "doppio_operatore": "Doppio operatore",
  "sconto": "Sconto",
  "fatturazione": "Fatturazione",
  "conferma_creazione": "Conferma creazione",
  "Prezzo base": "Prezzo base",
  "Rich. carrozzina": "Richiesta carrozzina",
  "Agg. Dimissione": "Supplemento dimissione",
  "Weekend": "Weekend",
  "Notturno": "Notturno",
  "Doppio operatore": "Doppio operatore",
  "Sconto": "Sconto",
  "fermo_auto_incluso": "Fermo auto incluso",
  "fermo_auto_non_incluso": "Non incluso nel prezzo totale: varia in base ai minuti di fermo effettivi.",
  "costo_passeggeri": "Costo passeggeri",
  "maggiorazione_weekend": "Maggiorazione weekend",
  "maggiorazione_notturna": "Maggiorazione notturna",
  "dettaglio_costi": "Dettaglio costi",
  "gestione_pagamento": "Gestione pagamento",
  "riepilogo_e_pagamento": "Riepilogo e pagamento",
  "pagamenti_e_fatture": "Pagamenti e fatture",
  "nessun_contratto": "Nessun contratto",
  "nessuna_fattura_emessa": "Nessuna fattura emessa",
  "assenza_per_tutti": "Assenza per tutti",
  "assenza_per_tutti_hint": "Registra un'assenza per tutti gli utenti visibili (festività, chiusura)",
  "nessuno_scontrino_disponibile": "Nessuno scontrino disponibile",
  "carica_scontrino": "Carica foto scontrino",
  "sostituisci_scontrino": "Sostituisci foto scontrino",
  "errore_caricamento_scontrino": "Caricamento dello scontrino non riuscito",
  "caricamento_storico": "Caricamento storico…",
  "nessuno_storico_disponibile": "Nessuno storico disponibile",
  "importo": "Importo",
  "scadenza_veicolo": "Scadenza veicolo",
  "scadenza_imminente": "Scadenza imminente",
  "scadenza_prossima": "Scadenza prossima",
  "revisione": "Revisione",
  "assicurazione": "Assicurazione",
  "omologazione": "Omologazione",
  "scade_oggi": "scade oggi",
  "scade_domani": "scade domani",
  "scade_tra_giorni": "scade tra {{days}} giorni",
  "scaduta_da_giorni": "scaduta da {{days}} giorni",
  "scadenza_label": "Scadenza",
  "driver_warning": "Avviso guidatore",
  "segnalazione": "Segnalazione",
  "nessun_commento": "Nessun commento",
  "driver": "Guidatore",
  "nuovo_ordine_per": "Nuovo ordine per",
  "ordine_annullato_per": "Ordine annullato per",
  "ordine_aggiornato_per": "Ordine aggiornato per",
  "previsto": "Previsto",
  "evento": "Evento",
  "ordine": "Ordine",
  "creato": "creato",
  "unknown": "Sconosciuto",
  "presa_visione": "Presa visione",
  "evento_completato": "Evento completato",
  "msg_presa_visione": "L'evento è stato visualizzato",
  "msg_evento_completato": "L'evento è stato completato",
  "posizione": "Posizione",
  "vedi_mappa": "Vedi mappa",
  "driverVehicle": "Autista / Veicolo",
  "activityType": "Tipo attività",
  "departure": "Partenza",
  "arrival": "Arrivo",
  "nextEvent": "Prossimo evento",
  "fleetStatus": "Stato flotta",
  "shift": "Turno",
  "position": "Posizione",
  "details": "Dettagli",
  "Disponibile": "Disponibile",
  "Non disponibile": "Non disponibile",
  "-": "-",
  "Turno": "Turno",
  "Ferie": "Ferie",
  "Malattia": "Malattia",
  "In Presidio": "In Presidio",
  "Fleet Status": "Stato Flotta",
  "Completato da APP": "Completato da APP",
  "common.tomorrow": "Domani",
  "Viaggio": "Viaggio",
  "vicino partenza": "Vicino alla partenza",
  "completato": "Completato",
  "A bordo": "A bordo",
  "Secondo Operatore": "Secondo Operatore",
  "privacyConsent": "Per procedere: autorizza Mbility al trattamento dei suoi dati per gestire la prenotazione e contattarla via telefono ed email? E separatamente, autorizza anche l’invio di comunicazioni commerciali e promozionali Mbility via telefono ed email? Può revocare il consenso in qualsiasi momento",
  "stationed_malpensa": "In Presidio (Malpensa)",
  "permission": "Permesso",
  "Assistenza Partenza": "Assistenza Partenza",
  "Viaggio Car-Pooling": "Viaggio Car-Pooling",
  "n_fatture": "N. fatture",
  "mercato_b2c": "Mercato B2C",
  "mercato_b2c_sottotitolo": "Analisi del mercato consumer (sito, BOT, APP)",
  "carrelli_abbandonati": "Carrelli abbandonati",
  "da_verificare": "Da verificare",
  "valore_totale": "Valore totale",
  "carrelli_abbandonati_app": "Carrelli abbandonati APP",
  "ordini_da_sito": "Ordini da sito",
  "ordini_da_app": "Ordini da APP",
  "preventivi_bot": "Preventivi BOT",
  "ordini_web": "Ordini web",
  "nessun_record_nel_periodo": "Nessun record nel periodo selezionato",
  "nessun_record_per_i_filtri": "Nessun record corrisponde ai filtri",
  "errore_apertura_viaggio": "Impossibile aprire il viaggio",
  "tutti_i_canali": "Tutti i canali",
  "tutti_gli_stati": "Tutti gli stati",
  "pagati_e_non": "Pagati e non",
  "non_pagato": "Non pagato",
  "prezzo_medio_b2c": "Prezzo Medio B2C",
  "fatturato_b2c": "Fatturato B2C",
  "numero_utenti_label": "Numero di Utenti",
  "applica": "Applica",
  "fatturato_e_prezzo_medio_b2c": "Fatturato e Prezzo Medio B2C",
  "metodi_pagamento_b2c": "Metodi di Pagamento B2C",
  "demografia_utenti_totale": "Demografia Utenti (Totale Piattaforma)",
  "corse": "corse",
  "utenti_privati_totali": "utenti privati totali",
  "nessun_dato_disponibile": "Nessun dato disponibile",
  "nessun_dato_filtri": "Nessun dato disponibile per i filtri selezionati",
  "ordini": "Ordini",
  "autisti_in_turno": "Autisti in turno",
  "riempimento": "Riempimento",
  "eta_arrivo": "ETA Arrivo",
  "passeggero_dest": "Passeggero / Destinazione",
  "mostra_mappa": "Mostra mappa",
  "Disp": "Disp.",
  "elenco aziende": "Elenco aziende",
  "Utenti di": "Utenti di",
  "Aggiungi utente": "Aggiungi utente",
  "no_data_available": "Nessun dato disponibile",
  "campi_opzionali": "Campi opzionali",
  "assenza_ingiustificata": "Assenza Ingiustificata",
  "geofences": "Geofence",
  "geofence_zones": "Zone Geofence",
  "zone_name": "Nome zona",
  "carica_geojson": "Carica GeoJSON",
  "incolla_geojson": "Incolla qui il contenuto GeoJSON",
  "nessuna_zona": "Nessuna zona disponibile",
  "zona_caricata": "Zona caricata con successo",
  "zona_eliminata": "Zona eliminata con successo",
  "errore_caricamento_zona": "Errore nel caricamento della zona",
  "errore_eliminazione_zona": "Errore nell'eliminazione della zona",
  "json_non_valido": "JSON non valido",
  "seleziona_zona": "Seleziona una zona per visualizzarla sulla mappa",
  "caricamento_mappa": "Caricamento...",
  "elimina_zona": "Elimina zona",
  "geofences_from": "Zone di partenza",
  "geofences_to": "Zone di arrivo",
  "companies_fields": "Campi aziende",
  "max_usages": "Utilizzi massimi",
  "max_usages_placeholder": "Lascia vuoto = illimitato",
  "nuovo_voucher": "Nuovo Voucher",
  "lunghezza_massima_caratteri": "Lunghezza massima caratteri:",
  "errore_invio_email": "Errore durante l'invio dell'email",
  "planning": "Pianifica",
  "invia_preventivo": "Invia preventivo",
  "preventivo_inviato": "Preventivo inviato",
  "quotation_email": {
    "title": "Email di preventivo",
    "send": "Invia",
    "to": "A",
    "from": "Da",
    "prezzo": "Prezzo",
    "no_email": "Indirizzo email del cliente mancante: impossibile inviare il preventivo."
  },
  "a_capo": "A capo dopo il campo",
  "abilita_multiservizio": "Abilita prenotazione multiservizio",
  "abilita_multiservizio_hint": "Permette di prenotare più servizi (treno, assistenza, ...) in un'unica richiesta.",
  "accorpa_car_pooling": "Accorpa car pooling",
  "aggiorna_utente": "Aggiorna utente",
  "aggiungi_pausa": "Aggiungi pausa",
  "aggiungi_voce": "Aggiungi una voce",
  "al": "Al",
  "idoneita": "Idoneità",
  "operativita": "Operatività",
  "criticita": "Criticità",
  "esercizio": "Esercizio",
  "rapporto_lavoro": "Rapporto di lavoro",
  "inizio_rapporto": "Inizio rapporto",
  "fine_rapporto": "Fine rapporto",
  "anagrafica": "Anagrafica",
  "annullati": "Annullati",
  "annullati_24h": "Annullati (24h)",
  "api_legacy": "Avanzate — URL assoluto (legacy)",
  "api_legacy_hint": "Usa questi campi solo senza un Client API: il backend chiamerà direttamente l’URL indicato (fallback per vecchie integrazioni).",
  "api_parameters": "Parametri da altri campi (CSV)",
  "api_parameters_hint": "Nomi di altri campi il cui valore viene usato come input della chiamata (il primo diventa il valore trigger).",
  "area_di_servizio": "Area di servizio",
  "arrivalTime": "Orario di arrivo",
  "assegnazione_singolo_viaggio": "Assegnazione singolo viaggio",
  "assente": "Assente",
  "assenza_split_hint": "L'assenza verrà divisa in più periodi.",
  "assenza_utente": "Assenza utente",
  "assenza_viaggio": "Assenza viaggio",
  "assenze_autisti": "Assenze e turni speciali",
  "assenze_totali": "Registrazioni totali",
  "assenze_utente": "Assenze utente",
  "assenze_viaggio": "Assenze viaggio",
  "attiva": "Attiva",
  "attive": "Attive",
  "attivi": "Attivi",
  "aumenta": "Aumenta",
  "autisti_coinvolti": "Autisti coinvolti",
  "avvisi_autisti": "Avvisi autisti",
  "avvisi_totali": "Avvisi totali",
  "avviso": "Avviso",
  "azioni_selezione": "Azioni sulla selezione",
  "barr_arch_arrivo": "Barriere arr.",
  "barr_arch_partenza": "Barriere part.",
  "calcola_tutti_prezzi": "Calcola tutti i prezzi",
  "cambia_gestore": "Cambia gestore",
  "cambia_indirizzo": "Cambia indirizzo",
  "cambia_indirizzo_selezionati": "Cambia indirizzo selezionati",
  "campi_extra": "Campi extra",
  "capacita_carica_non_valida": "Capacità di carico non valida",
  "capacita_non_valida": "Capacità non valida",
  "Capienza": "Capienza",
  "car_pooling": "Car pooling",
  "caratteristiche": "Caratteristiche",
  "censiti": "Censiti",
  "censito": "Censito",
  "cerca_globale": "Cerca autisti, mezzi, aziende, utenti…",
  "cerca_utente": "Cerca utente",
  "churn_anno_aperto_note": "L'anno in corso non è ancora concluso: il dato è parziale.",
  "clicca_per_visualizzare_nascondere_ordini": "Clicca per mostrare o nascondere gli ordini",
  "client_api": "Client API (cosa chiamare)",
  "client_api_hint": "Integrazione da invocare lato backend (es. Trenord). Lascia vuoto per usare l’URL assoluto legacy in fondo.",
  "close": "Chiudi",
  "come_vuoi_modificare_pianificato": "Come vuoi modificare questo pianificato?",
  "commento": "Commento",
  "commessa_con": "Con commessa",
  "commessa_senza": "Senza commessa",
  "commessa_tutte": "Tutte le commesse",
  "commesse": "commesse",
  "con_autista": "Con autista",
  "con_azienda": "Con azienda",
  "con_email": "Con email",
  "con_moduli_attivi": "Con moduli attivi",
  "con_pagamento": "Con pagamento",
  "condizioni_paziente": "Condizioni del paziente",
  "confirm_delete_company": "Sei sicuro di voler eliminare questa azienda?",
  "confirm_delete_user": "Sei sicuro di voler eliminare questo utente?",
  "consenso_privacy": "Consenso privacy",
  "contatti": "Contatti",
  "controllo_operativo": "Controllo operativo",
  "coordinates": "Coordinate",
  "course_16h": "Corso 16h",
  "crea_utente": "Crea utente",
  "da_assegnare": "Da assegnare",
  "dal": "Dal",
  "data_e_orario": "Date e orari",
  "data_esecuzione": "Data esecuzione",
  "data_inserimento": "Data inserimento",
  "data_non_valida": "Data non valida",
  "data_scadenza_non_valida": "Data di scadenza non valida",
  "data_segnalazione": "Data segnalazione",
  "data_viggio_non_valida": "Data viaggio non valida",
  "dati_account": "Dati account",
  "dato_in_corso": "Dato in corso",
  "departureTime": "Orario di partenza",
  "descrizione_nota": "Descrizione / nota (mostrata sotto il campo)",
  "descrizione_nota_hint": "Testo di aiuto/avviso mostrato all’utente (es. sotto una checkbox quando è spuntata).",
  "dettagli_assistenza": "Dettagli assistenza",
  "dettagli_collo": "Dettagli collo",
  "dettagli_servizio": "Dettagli servizio",
  "dettagli_servizio_orario": "Servizio & orario",
  "dettagli_viaggio_treno": "Posto e assistenza",
  "diminuisci": "Diminuisci",
  "dimissione": "Dimissione",
  "dipendenze": "Dipendenze (altri campi)",
  "dipendenze_hint": "Il campo è visibile solo quando tutti i campi selezionati sono valorizzati/attivi.",
  "disattiva": "Disattiva",
  "disattiva_gestore": "Disattiva gestore",
  "disattivata": "Disattivata",
  "disattivate": "Disattivate",
  "disattivi": "Disattivi",
  "disattivo": "Disattivo",
  "distanza_gps": "Distanza GPS",
  "distanza_non_valida": "Distanza non valida",
  "donne": "Donne",
  "driver_non_valido": "Autista non valido",
  "driver_position": "Posizione autista",
  "durata_non_valida": "Durata non valida",
  "eccezione_per_data": "Eccezione per data",
  "eccezioni": "Eccezioni",
  "eccezioni_per_data": "Eccezioni per data",
  "elenco_assenze": "registrazioni",
  "elenco_driverwarnings": "avvisi",
  "elimina_gestore": "Elimina utente gestore",
  "equipaggiamento_sanitario": "Equipaggiamento e accompagnamento",
  "error_adding_trips": "Errore durante l'aggiunta dei viaggi",
  "errore_aggiornamento_utente": "Errore durante l'aggiornamento dell'utente",
  "errore_creazione_utente": "Errore durante la creazione dell'utente",
  "errore_eliminazione_evento": "Errore durante l'eliminazione dell'evento",
  "errore_lettura_file": "Errore nella lettura del file",
  "errore_rimozione": "Errore durante la rimozione",
  "errore_rimozione_equipaggiamento": "Errore durante la rimozione dell'equipaggiamento",
  "errori": "Errori",
  "esporta_ore_autisti": "Esporta ore autisti",
  "esporta_xlsx": "Esporta XLSX",
  "esporta_presenze": "Esporta presenze",
  "eventi_recenti": "Eventi recenti",
  "evento_eliminato": "Evento eliminato",
  "fattura_selezionati": "Fattura selezionati",
  "filter_function": "Filtro (funzione)",
  "filter_function_hint": "Nome di una funzione di filtro registrata nel backend (es. trainFilter) applicata alla risposta.",
  "filtra_gestore": "Filtra gestore",
  "filtra_per_date": "Filtra per date",
  "fonte_gestionale": "Gestionale",
  "fromVehicleToStart": "Dal mezzo alla partenza",
  "genera_export": "Genera export",
  "gestione_pause": "Gestione pause",
  "gia_tornati": "Già tornati",
  "gia_tornati_short": "Tornati",
  "giornaliero": "Giornaliero",
  "giorni_pagamento": "Giorni di pagamento",
  "giorni_viaggio": "Giorni viaggio",
  "giu": "Giù",
  "gps_seleziona_periodo": "Seleziona un periodo e premi Carica",
  "headers_json": "Headers (JSON)",
  "heatmap_ordini": "Heatmap ordini",
  "hide_fields": "Nascondi questi campi al cambio valore",
  "hide_fields_hint": "I campi selezionati vengono nascosti quando questo campo viene attivato/valorizzato.",
  "import_completato": "Import completato",
  "importa": "Importa",
  "importa_mezzi": "Importa mezzi da Excel",
  "importa_viaggi": "Importa viaggi",
  "importa_xls": "Importa XLS",
  "in_attesa": "In attesa",
  "indirizzo_fine": "Indirizzo di fine",
  "indirizzo_inizio": "Indirizzo di inizio",
  "indirizzo_non_valido": "Indirizzo non valido",
  "integration_desc_trenord": "Consente ai campi treno (numero treno, rete) di interrogare le API Trenord per stato treno e ricerca orari.",
  "integrazione_api": "Integrazione API",
  "integrazione_api_hint": "Collega il campo a un servizio esterno tramite il resolver backend: al cambio valore chiama l’API e popola altri campi con la risposta.",
  "json_invalido": "JSON non valido",
  "kb": "KB",
  "lascia_vuoto_per_non_modificare": "Lascia vuoto un campo per non modificarlo.",
  "last_update": "Ultimo aggiornamento",
  "logica_campo_campo": "Logica campo → campo",
  "logica_campo_campo_hint": "Automazioni tra campi dello stesso form: al cambio di questo campo puoi aggiornarne o nasconderne altri.",
  "luogo_assistenza": "Luogo assistenza",
  "metodo_http": "Metodo HTTP",
  "modalita": "Modalità",
  "modalita_fatturazione": "Modalità di fatturazione",
  "mode_api": "API (software esterno)",
  "mode_api_desc": "Gli ordini sono gestiti dal software esterno del partner, che aggiorna lo stato via webhook. Nessun inserimento manuale sul gestionale.",
  "mode_hybrid": "Ibrido",
  "mode_hybrid_desc": "Gli ordini arrivano dal software esterno ma possono essere gestiti anche manualmente dagli operatori.",
  "mode_portal": "Portale (manuale)",
  "mode_portal_desc": "Gli ordini sono gestiti manualmente dagli operatori sul gestionale. Nessuna sincronizzazione automatica con sistemi esterni.",
  "Modello": "Modello",
  "modifica_assenza": "Modifica assenza o turno",
  "modifica_avviso": "Modifica avviso",
  "modifica_campo": "Modifica campo",
  "modifica_gestore": "Modifica gestore",
  "modifica_pianificato": "Modifica pianificato",
  "modifica_utente": "Modifica utente",
  "moduli_attivi": "Moduli attivi",
  "mostra_altri": "Mostra altri",
  "mostra_annullati": "Mostra annullati",
  "motivo": "Motivo",
  "nascondi_annullati": "Nascondi annullati",
  "nascosto": "Nascosto",
  "nel": "nel",
  "nessun_annullato": "Nessun annullamento",
  "nessun_avviso": "Nessun avviso",
  "nessun_cliente": "Nessun cliente",
  "nessun_equipaggiamento": "Nessun equipaggiamento assegnato",
  "nessun_indirizzo": "Nessun indirizzo",
  "nessun_mezzo_nel_file": "Nessun mezzo trovato nel file",
  "nessun_modulo": "Nessuno",
  "nessun_nuovo_viaggio": "Nessun nuovo viaggio",
  "nessun_ordine": "Nessun ordine",
  "nessun_ordine_filtri": "Nessun ordine trovato per i filtri selezionati.",
  "nessun_pianificato": "Nessun viaggio pianificato",
  "nessun_risultato": "Nessun risultato",
  "nessun_utente_azienda": "Nessun utente per questa azienda",
  "nessun_utente_cdi": "Nessun utente trovato per questa CDI",
  "nessun_utente_gestore_msg": "Nessun utente gestore assegnato a questo gestore.",
  "nessun_viaggio": "Nessun viaggio",
  "nessun_viaggio_filtri": "Nessun viaggio attivo per i filtri selezionati.",
  "nessun_viaggio_pianificato": "Nessun viaggio pianificato",
  "nessun_viaggio_selezionato": "Nessun viaggio selezionato",
  "nessun_viaggio_trovato": "Nessun viaggio trovato per i filtri selezionati.",
  "nessuna_assenza": "Nessuna assenza",
  "nessuna_assenza_periodo": "Nessuna assenza trovata per il periodo selezionato",
  "nessuna_corsa": "Nessuna corsa giornaliera",
  "nessuna_modifica": "Nessuna modifica da salvare",
  "nessuna_pausa_definita": "Nessuna pausa definita",
  "nome_univoco": "Nome univoco (es: badge_id)",
  "non_ancora_tornati": "Non ancora tornati",
  "normali": "Normali",
  "notifiche_email": "Notifiche email",
  "numero_civico": "Numero civico",
  "nuova_assenza": "Nuova assenza o turno speciale",
  "nuovi_viaggi_24h": "Nuovi viaggi (24h)",
  "nuovo_account": "Nuovo account",
  "nuovo_avviso": "Nuovo avviso",
  "nuovo_campo": "Nuovo campo",
  "nuovo_gruppo": "Nuovo gruppo",
  "nuovo_pianificato": "Nuovo pianificato",
  "nuovo_viaggio_pianificato": "Nuovo viaggio pianificato",
  "on_change_update": "Aggiorna questi campi al cambio valore",
  "on_change_update_hint": "Quando questo campo cambia, i campi selezionati vengono valorizzati con i dati derivati (es. da extra della risposta).",
  "operativo": "Operativo",
  "opzioni_select": "Opzioni della select",
  "ora": "Ora",
  "ora_fine": "Ora fine",
  "ora_inizio": "Ora inizio",
  "ora_non_valida": "Ora non valida",
  "ordini_app": "Ordini app",
  "ordini_bot": "Ordini bot",
  "ordini_selezionati": "ordine/i selezionato/i",
  "ordini_sito": "Ordini sito",
  "ownership_leasing": "Leasing",
  "ownership_owned": "Proprietà",
  "ownership_rental": "Noleggio",
  "panoramica_operativa": "Panoramica operativa",
  "param_map": "Mappa parametri (JSON) — multi-input",
  "param_map_hint": "Per chiamate con più input (es. motore orario): associa ogni parametro dell’API al nome del campo del form da cui prendere il valore. Ideale con un campo di tipo Button.",
  "params_json": "Params statici (JSON)",
  "per_referrer": "Per referrer",
  "per_sempre_modifica_pianificato": "Per sempre (modifica pianificato)",
  "per_sesso": "Per sesso",
  "periodo": "Periodo",
  "persi": "Persi",
  "pianifica_viaggi_settimana": "Aggiungi uno o più viaggi per ogni giorno",
  "pianificati_attivi": "Pianificati",
  "pianificato": "Pianificato",
  "populate": "Campi da popolare con la risposta",
  "populate_hint": "Campi che vengono riempiti (opzioni/valore) con i dati della risposta, secondo il response mapper.",
  "posizione_hint": "Ordine di visualizzazione nella sezione: numeri più bassi appaiono prima. Vuoto = in fondo.",
  "posizione_live": "Posizione live",
  "punto_scambio": "Punto di scambio",
  "quando": "Quando",
  "query_param": "Query param (es: dep_time)",
  "query_param_hint": "Nome del parametro querystring con cui inviare il valore del campo alla chiamata.",
  "response_mapper": "Response mapper (JSON)",
  "response_mapper_hint": "Descrive come leggere la risposta dell’API per popolare i campi collegati.",
  "response_mapper_json_invalido": "Il response_mapper non è un JSON valido.",
  "riattiva": "Riattiva",
  "riattiva_gestore": "Riattiva gestore",
  "ricerca_in_corso": "Ricerca in corso…",
  "richiedente": "Richiedente",
  "rimozione_riuscita": "Rimozione riuscita",
  "cerca_passeggero_indirizzo_azienda": "Passeggero, indirizzo, azienda…",
  "rimuovi_filtri": "Rimuovi filtri",
  "rimuovi_pausa": "Rimuovi pausa",
  "rimuovi_viaggio_dal_gruppo": "Rimuovere questo viaggio dal gruppo?",
  "ripristina_questa_corsa": "Ripristina questa corsa",
  "riprova": "Riprova",
  "salvataggio": "Salvataggio in corso…",
  "Scadenza": "Scadenza",
  "scadenze_da_gestire": "Scadenze da gestire",
  "scaduto": "Scaduto",
  "segnali_operativi": "Segnali operativi",
  "seleziona_campi": "Seleziona campi...",
  "seleziona_centro_diurno_desc": "Scegli un centro dal menu in alto per visualizzare e gestire i viaggi della settimana.",
  "seleziona_centro_diurno_hint": "Seleziona un centro diurno per continuare.",
  "seleziona_centro_diurno_titolo": "Seleziona un Centro Diurno",
  "seleziona_client": "Seleziona client...",
  "seleziona_data": "Seleziona data",
  "seleziona_dipendenze": "Seleziona dipendenze...",
  "seleziona_file_tracciato": "Seleziona un file tracciato per l’anteprima",
  "seleziona_fine": "Seleziona la data di fine",
  "seleziona_hub": "Seleziona hub",
  "seleziona_inizio": "Seleziona la data di inizio",
  "seleziona_servizi": "Seleziona servizi...",
  "seleziona_zone": "Seleziona zone...",
  "selezionati": "selezionati",
  "selezionato": "selezionato",
  "selezione_multipla": "Consenti selezione multipla",
  "senza_pagamento": "Senza pagamento",
  "sequenza_tappe": "Sequenza tappe",
  "servizio_multiservizio": "Servizi (multiservizio)",
  "servizio_multiservizio_hint": "Nelle prenotazioni multiservizio, associa il campo a uno o più servizi (treno/assistenza/...). Ogni servizio diventa un order distinto; un campo su più servizi viene duplicato in ciascun order. Vuoto = campo comune, incluso in tutti gli order.",
  "settimana_precedente": "Settimana precedente",
  "settimana_successiva": "Settimana successiva",
  "sezione": "Sezione",
  "sezione_form": "Sezione form viaggio",
  "sezione_in_arrivo": "Sezione in arrivo",
  "sicuro_disattiva_gestore": "Il gestore non sarà più selezionabile per nuovi servizi (es. nelle prenotazioni). Continuare?",
  "sicuro_rimuovi_cliente": "Sei sicuro di voler cancellare questo cliente?",
  "sicuro_rimuovi_equipaggiamento": "Sei sicuro di voler rimuovere questo equipaggiamento?",
  "sicuro_rimuovi_gestore": "Sei sicuro di voler eliminare questo utente gestore?",
  "sicuro_rimuovi_hub": "Sei sicuro di voler rimuovere questo hub?",
  "sito_web": "Sito web",
  "sola_lettura": "Sola lettura",
  "solo_preprod": "Solo pre-produzione (test)",
  "sosta": "Sosta",
  "sosta_min_sec": "Sosta min (s)",
  "spostamento_max_m": "Spostamento max (m)",
  "step": "Gradino",
  "su": "Su",
  "surname": "Cognome",
  "switch_group_hint": "Obbligatorio/Sola lettura/Nascosto controllano input e visibilità. “A capo” forza l’a-capo nella griglia. “Solo pre-produzione” mostra il campo solo agli admin (test), nascondendolo agli utenti finali.",
  "tasso_abbandono_b2c": "Tasso di abbandono B2C",
  "tempo_ritorno": "Tempo di ritorno",
  "tipo_avviso": "Tipo di avviso",
  "tipo_campo": "Tipo campo",
  "tipo_non_valido": "Tipo non valido",
  "tipologia_servizio": "Tipologia di servizio",
  "totale_scadenze": "Totale scadenze",
  "trasporto_oggetti": "Trasporto oggetti",
  "tratta_stazioni": "Tratta stazioni",
  "trattenuti": "Trattenuti",
  "trigger_api": "Chiama API al cambio valore",
  "trigger_on_change_update": "Condizioni che abilitano l’aggiornamento",
  "trigger_on_change_update_hint": "L’aggiornamento sopra avviene solo se questi campi risultano attivi/valorizzati. Vuoto = sempre.",
  "trips_added_successfully": "Viaggi aggiunti correttamente",
  "tutti_autisti": "Tutti gli autisti",
  "tutti_i_gestori": "Tutti i gestori",
  "tutti_i_viaggi": "Tutti i viaggi",
  "tutto_ok": "Tutto ok",
  "tyre_all_season": "Quattro stagioni",
  "tyre_summer": "Estive",
  "tyre_winter": "Invernali",
  "ultima_settimana": "Ultima settimana",
  "ultimi_30_giorni": "Ultimi 30 giorni",
  "uomini": "Uomini",
  "utente_aggiornato": "Utente aggiornato",
  "utente_creato": "Utente creato",
  "utente_non_valido": "Utente non valido.",
  "valore_default": "Valore di default",
  "valore_perso": "Valore perso",
  "validator_function": "Validatore (funzione)",
  "validator_function_hint": "Nome di una funzione di validazione backend (es. trainDate): se fallisce mostra un avviso all’utente.",
  "vedi_tutti": "Vedi tutti",
  "vedi_tutti_n_one": "Vedi tutti ({{count}})",
  "vedi_tutti_n_other": "Vedi tutti ({{count}})",
  "vehicle": "Veicolo",
  "veicolo_non_valido": "Veicolo non valido",
  "viaggi_di_oggi": "Viaggi di oggi",
  "viaggi_eseguiti": "Viaggi eseguiti",
  "viaggi_visibili": "Viaggi visibili",
  "viaggio_pianificato": "Viaggio pianificato",
  "visualizza_gruppo": "Visualizza gruppo",
  "vista": "Vista",
  "vista_carte": "Carte",
  "vista_compatta": "Vista compatta",
  "vista_estesa": "Vista estesa",
  "vista_tabella": "Tabella",
  "vuoi_cancellare_definitavamente_ordine": "Vuoi cancellare definitivamente questo ordine?",
  "vuoi_cancellare_evento": "Vuoi cancellare questo evento?",
  "wheelchair_lift": "Pedana carrozzina",
  "wheelchair_seats": "Posti carrozzina",
  "common": {
    "tomorrow": "Domani"
  },
  "planner": {
    "subtitle": "Pianifica e assegna i viaggi ricorrenti"
  },
  "Inserito": "Inserito",
  "Assegnato": "Assegnato",
  "Pagato": "Pagato",
  "Vicino Partenza": "Vicino Partenza",
  "Completato": "Completato",
  "Annullato": "Annullato",
  "Vicino Arrivo": "Vicino Arrivo",
  "Non Presentato": "Non Presentato",
  "Annullato (24h)": "Annullato (24h)",
  "Rifiutato": "Rifiutato",
  "Assente": "Assente",
  "tipo_hub": "Tipo hub",
  "hub_type_depot": "Deposito",
  "hub_type_station": "Stazione",
  "hub_type_stop": "Fermata",
  "hub_type_parking": "Parcheggio",
  "hub_type_charging": "Punto di ricarica",
  "localizzazione": "Localizzazione",
  "latitudine": "Latitudine",
  "longitudine": "Longitudine",
  "latitudine_non_valida": "Latitudine non valida",
  "longitudine_non_valida": "Longitudine non valida",
  "fuori_intervallo": "fuori intervallo",
  "avanti": "Avanti",
  "importa_hub": "Importa hub / stazioni",
  "stazione": "Stazione",
  "cerca_stazione": "Cerca una stazione…",
  "import_seleziona_file": "Seleziona un file JSON, Excel o CSV",
  "import_nessun_file": "Nessun file selezionato",
  "import_nessuna_riga": "Nessuna riga trovata nel file",
  "import_json_non_valido": "JSON non valido",
  "import_struttura_non_valida": "Il file non contiene un elenco di record",
  "import_foglio": "Foglio",
  "import_ignora": "— Ignora —",
  "import_valore_fisso": "Valore fisso…",
  "import_righe_lette": "{{count}} righe lette dal file",
  "import_riepilogo": "{{valid}} righe valide, {{invalid}} scartate",
  "import_righe_scartate": "Righe scartate",
  "import_riga": "Riga",
  "import_altre_righe": "… e altre {{count}}",
  "import_esito": "{{created}} creati, {{updated}} aggiornati, {{skipped}} ignorati",
  "import_errore_numero": "valore numerico non valido",
  "import_errore_obbligatorio": "obbligatorio",
  "import_tipo_non_valido": "tipo non riconosciuto",
  "opzioni_stazione": "Ricerca stazione",
  "station_input_hint": "Il campo cerca fra gli hub di questo tipo e salva la stazione scelta (codice, comune e coordinate) sulla prenotazione.",
  "email_config_title": "Flusso email",
  "email_config_enabled": "Invio email attivo",
  "email_config_enabled_hint": "Le email seguono la configurazione qui sotto. Un evento spento a monte (gestore o azienda) resta spento anche se attivo qui.",
  "email_config_disabled_hint": "Nessuna email verrà inviata. Gli invii bloccati restano tracciati nella scheda Comunicazioni con il motivo.",
  "email_config_sender": "Mittente e destinatari",
  "email_config_sender_name": "Nome mittente",
  "email_config_sender_email": "Email mittente",
  "email_config_reply_to": "Rispondi a",
  "email_config_copies": "Copie su tutte le email",
  "email_config_cc": "CC",
  "email_config_bcc": "CCN",
  "email_config_addresses_hint": "Più indirizzi separati da virgola.",
  "email_config_events": "Eventi",
  "email_config_template": "Template Brevo",
  "email_config_template_default": "Predefinito",
  "email_config_recipients_override": "Destinatari (sostituisce)",
  "email_event_trip_quote_summary": "Riepilogo e pagamento",
  "email_event_trip_quote_summary_desc": "Riepilogo del viaggio con link di pagamento e di conferma.",
  "email_event_quotation_sent": "Preventivo",
  "email_event_quotation_sent_desc": "Preventivo inviato al cliente.",
  "email_event_booking_confirmation_flexymob": "Conferma prenotazione FlexyMob",
  "email_event_booking_confirmation_flexymob_desc": "Conferma inviata per le prenotazioni provenienti da FlexyMob.",
  "email_event_order_einvoice": "Fattura elettronica",
  "email_event_order_einvoice_desc": "Inviata quando la fattura è accettata dallo SDI, con il PDF allegato.",
  "email_event_trip_created": "Viaggio creato",
  "email_event_trip_created_desc": "Notifica al cliente alla creazione del viaggio.",
  "email_event_trip_confirmed": "Viaggio confermato",
  "email_event_trip_confirmed_desc": "Notifica al cliente quando il viaggio passa in stato confermato.",
  "email_event_trip_updated": "Viaggio modificato",
  "email_event_trip_updated_desc": "Inviata se cambiano indirizzo di partenza, destinazione o data.",
  "email_event_trip_canceled": "Viaggio annullato",
  "email_event_trip_canceled_desc": "Notifica al cliente in caso di annullamento.",
  "email_event_trip_completed": "Viaggio completato",
  "email_event_trip_completed_desc": "Notifica al cliente a viaggio concluso.",
  "email_event_trip_reminder_24h": "Promemoria 24 ore",
  "email_event_trip_reminder_24h_desc": "Promemoria inviato il giorno prima del viaggio.",
  "email_event_trip_reminder_1h": "Promemoria 1 ora",
  "email_event_trip_reminder_1h_desc": "Promemoria inviato un’ora prima del viaggio.",
  "email_event_manual_trips_summary": "Riepilogo viaggi manuale",
  "email_event_manual_trips_summary_desc": "Riepilogo dei viaggi inviato a mano da un operatore.",
  "email_event_trenord_booking_created": "Trenord — assistenza confermata",
  "email_event_trenord_booking_created_desc": "Conferma della richiesta di assistenza, con stazioni e orari.",
  "email_event_trenord_booking_canceled": "Trenord — assistenza annullata",
  "email_event_trenord_booking_canceled_desc": "Annullamento della richiesta di assistenza.",
  "email_event_quotation_abandoned": "Preventivo non convertito",
  "email_event_quotation_abandoned_desc": "Recupero dei preventivi dal sito rimasti senza prenotazione.",
  "email_event_manager_assistance_request": "Richiesta di assistenza PRM",
  "email_event_manager_assistance_request_desc": "Nuova assistenza da eseguire, con stazione, data e tipo di invalidità.",
  "email_event_manager_trip_assigned": "Nuovo viaggio da gestire",
  "email_event_manager_trip_assigned_desc": "Notifica al gestore con i link per accettare o rifiutare.",
  "email_event_manager_trip_decision_confirm": "Conferma accettazione o rifiuto",
  "email_event_manager_trip_decision_confirm_desc": "Riepilogo inviato al gestore dopo la sua decisione.",
  "email_event_manager_trip_canceled": "Viaggio annullato",
  "email_event_manager_trip_canceled_desc": "Notifica al gestore quando il cliente annulla.",
  "email_event_company_planned_trip_approved": "Viaggio pianificato confermato",
  "email_event_company_planned_trip_approved_desc": "Notifica all’azienda alla conferma di un viaggio ricorrente.",
  "email_event_company_trips_summary": "Riepilogo viaggi",
  "email_event_company_trips_summary_desc": "Riepilogo periodico dei viaggi dell’azienda.",
  "email_event_company_users_trips_summary": "Riepilogo viaggi per utente",
  "email_event_company_users_trips_summary_desc": "Riepilogo periodico dei viaggi raggruppati per utente.",
  "email_event_internal_pending_request": "Richiesta viaggio ricorrente",
  "email_event_internal_pending_request_desc": "Segnalazione interna di una nuova richiesta.",
  "email_event_internal_job_alert": "Alert viaggi non gestiti",
  "email_event_internal_job_alert_desc": "Segnalazione interna dei viaggi rimasti senza gestione.",
  "telefono_principale": "Telefono principale",
  "telefono_aziendale": "Telefono aziendale",
  "telefono_privato": "Telefono privato",
  "indirizzo_residenza": "Indirizzo di residenza",
  "indirizzo_domicilio": "Indirizzo di domicilio",
  "domicilio_uguale_residenza": "Domicilio coincidente con la residenza",
  "tipologie_dotazione": "Tipologie dotazione",
  "nuovo_tipo_dotazione": "Nuova tipologia dotazione",
  "modifica_tipo_dotazione": "Modifica tipologia dotazione",
  "nessun_tipo_dotazione": "Nessuna tipologia",
  "nessun_tipo_dotazione_desc": "Crea le tipologie di dotazione (estintore, pedana, chiavi di backup…): ognuna può avere i propri campi.",
  "nessun_tipo_dotazione_hint": "Nessuna tipologia definita: creale nella tab \"Tipologie dotazione\".",
  "sicuro_rimuovi_tipo_dotazione": "Eliminare questa tipologia? Le dotazioni già create la mantengono, ma non sarà più selezionabile.",
  "nome_tipo_dotazione_placeholder": "es. Pedana, Chiavi di backup",
  "seleziona_tipologia": "Seleziona tipologia",
  "tipo_obbligatorio": "Seleziona una tipologia",
  "campi_standard": "Campi standard",
  "opzioni_separate_virgola": "Opzioni (separate da virgola)",
  "e_una_scadenza": "È una scadenza",
  "campo_testo": "Testo",
  "campo_data": "Data",
  "campo_numero": "Numero",
  "campo_scelta": "Scelta",
  "slug": "Slug tecnico",
  "icona": "Icona (nome Font Awesome)",
  "durata_ore": "Durata (ore)",
  "scadenza_corso_autista": "Corso autista scaduto",
  "corsi_certificazioni": "Corsi e certificazioni",
  "nessun_corso": "Nessun corso registrato",
  "aggiungi_corso": "Aggiungi corso",
  "nuovo_corso": "Nuovo corso o certificazione",
  "modifica_corso": "Modifica corso",
  "sicuro_rimuovi_corso": "Eliminare questo corso?",
  "nome_corso": "Nome corso",
  "categorie_patente": "Categorie",
  "ente_rilasciante": "Ente rilasciante",
  "data_conseguimento": "Data conseguimento",
  "data_rinnovo": "Data ultimo rinnovo",
  "deadline_cat_driver_course": "Corso autista",
  "mezzo_autista": "Mezzo / Autista",
  "driver_course_patente": "Patente di guida",
  "driver_course_cqc": "CQC",
  "driver_course_carta_tachigrafica": "Carta tachigrafica",
  "driver_course_corso_16h": "Corso 16 ore",
  "driver_course_kb": "KB",
  "driver_course_blsd": "BLSD",
  "driver_course_primo_soccorso": "Primo soccorso",
  "driver_course_antincendio": "Antincendio",
  "driver_course_haccp": "HACCP",
  "driver_course_dpi": "DPI",
  "driver_course_formazione_generale": "Formazione generale sicurezza",
  "driver_course_formazione_specifica": "Formazione specifica sicurezza",
  "driver_course_altro": "Altro",
  "carrozzine_supportate": "Carrozzine supportate",
  "carrozzina_pieghevole": "Pieghevole",
  "carrozzina_rigida": "Rigida",
  "carrozzina_motorizzata": "Motorizzata",
  "carrozzina_altro": "Altro",
  "posti_carrozzina_disallineati": "I posti carrozzina dichiarati ({{declared}}) non coincidono con quelli nel layout ({{layout}}).",
  "date_contratto": "Date di contratto",
  "scadenze_documentali": "Scadenze documentali",
  "gestore_non_accessibile": "Gestore del mezzo non accessibile",
  "gestore_non_accessibile_desc": "Il gestore associato al mezzo non è tra quelli visibili con il tuo profilo, oppure il mezzo non ha un gestore assegnato.",
  "gps_caricamento_gestore": "Recupero della configurazione del gestore in corso.",
  "errore_caricamento_gps": "Errore nel caricamento dei dati GPS",
  "nome_gia_esistente": "Esiste già una voce con questo nome in questa cartella",
  "spostamento_in_corso": "Spostamento in corso",
  "maintenance_insurance": "Assicurazione",
  "maintenance_homologation": "Omologazione",
  "maintenance_ownership": "Scadenza proprietà",
  "maintenance_road_tax": "Bollo",
  "bollo": "Bollo",
  "maintenance_registration": "Immatricolazione",
  "data_emissione": "Data emissione",
  "data_scadenza": "Data di scadenza",
  "documento_sync_hint": "La data di scadenza aggiorna il documento sull'anagrafica del mezzo e alimenta scadenzario e notifiche.",
  "da_registrare": "Da registrare",
  "registra_intervento": "Registra intervento",
  "operazione_in_corso": "Operazione in corso",
  "pagina_non_trovata": "Pagina non trovata",
  "pagina_non_trovata_msg": "Il percorso richiesto non esiste o non è più disponibile.",
  "torna_alla_home": "Torna alla home",
  "nuova_dotazione": "Nuova dotazione",
  "codice_obbligatorio": "Il codice è obbligatorio",
  "documenti_gestore": "Documenti del gestore",
  "documenti_azienda": "Documenti dell'azienda",
  "documenti_cliente": "Documenti del cliente",
  "danni": "Danni",
  "vehicle_damage": "Danno mezzo",
  "segnala_danno": "Segnala danno",
  "modifica_danno": "Modifica segnalazione",
  "nessun_danno": "Nessun danno segnalato",
  "sicuro_rimuovi_danno": "Eliminare questa segnalazione di danno?",
  "dettagli_danno": "Dettagli del danno",
  "area_danno": "Area",
  "seleziona_area": "Seleziona area",
  "area_obbligatoria": "Seleziona l'area",
  "titolo_obbligatorio": "Il titolo è obbligatorio",
  "titolo": "Titolo",
  "componente": "Componente",
  "gravita": "Gravità",
  "mezzo_non_utilizzabile": "{{count}} danno bloccante aperto: il mezzo non deve essere utilizzato.",
  "mezzo_non_utilizzabile_plural": "{{count}} danni bloccanti aperti: il mezzo non deve essere utilizzato.",
  "damage_area_bodywork": "Carrozzeria",
  "damage_area_scratches": "Graffi",
  "damage_area_dents": "Ammaccature",
  "damage_area_glass": "Vetri e specchietti",
  "damage_area_interior": "Interni e vano passeggeri",
  "damage_area_seats_upholstery": "Sedili e rivestimenti",
  "damage_area_flooring": "Pavimentazione",
  "damage_area_ramp_lift": "Pedana / sollevatore",
  "damage_area_accessories": "Accessori",
  "damage_area_worn_components": "Componenti usurati",
  "damage_area_other": "Altro",
  "damage_severity_low": "Lieve",
  "damage_severity_medium": "Media",
  "damage_severity_high": "Grave",
  "damage_severity_blocking": "Bloccante",
  "damage_status_reported": "Segnalato",
  "damage_status_in_progress": "In lavorazione",
  "damage_status_resolved": "Risolto",
  "damage_status_dismissed": "Archiviato",
  "damage_status_open": "Aperti",
  "driver_status_active": "Attivo",
  "driver_status_training": "In formazione",
  "driver_status_resigning": "Dimissionario",
  "driver_status_inactive": "Inattivo",
  "driver_status_assignable": "Operativi",
  "stato_autista": "Stato autista",
  "mostra_inattivi": "Mostra inattivi",
  "contratto_terminato_hint": "Contratto terminato il {{date}} — valuta lo stato \"Inattivo\"",
  "stato_non_valido": "Stato non valido",
  "nascondi_inattivi": "Nascondi inattivi",
  "vehicle_status_decommissioned": "Dismesso",
  "vehicle_status_sold": "Venduto",
  "mezzi_in_flotta": "In flotta",
  "mezzi_operativi": "Operativi",
  "mezzi_fermi": "Fermi",
  "violation_type_multa": "Multa",
  "violation_type_sinistro": "Sinistro",
  "violation_status_pending": "Da pagare",
  "violation_status_contested": "Ricorso",
  "violation_status_charged": "Addebitata all'autista",
  "violation_status_paid": "Pagata",
  "violation_status_written_off": "Stralciata",
  "violation_status_open": "Aperte",
  "violation_responsibility_unknown": "Da attribuire",
  "violation_responsibility_driver": "Autista",
  "violation_responsibility_company": "Azienda",
  "violation_responsibility_third_party": "Controparte",
  "multe_e_sinistri": "Multe e sinistri",
  "verbale": "Verbale",
  "verbali": "Verbali",
  "nuovo_verbale": "Nuovo verbale",
  "modifica_verbale": "Modifica verbale",
  "sicuro_rimuovi_multa": "Eliminare questo verbale?",
  "nessuna_multa": "Nessun verbale",
  "nessuna_multa_autista": "Nessun verbale attribuito a questo autista",
  "multe_scadute": "{{count}} verbali oltre la scadenza di pagamento.",
  "dati_verbale": "Dati del verbale",
  "numero_verbale": "Numero verbale",
  "data_infrazione": "Data infrazione",
  "data_notifica": "Data notifica",
  "ente_accertatore": "Ente accertatore",
  "importi_e_stato": "Importi e stato",
  "importo_ridotto": "Importo ridotto (€)",
  "scadenza_pagamento": "Scadenza pagamento",
  "data_pagamento": "Data pagamento",
  "punti_decurtati": "Punti decurtati",
  "responsabilita": "Responsabilità",
  "a_carico_di": "A carico di",
  "a_carico_autista": "A carico dell'autista",
  "ricorsi": "Ricorsi",
  "scadute": "Scadute",
  "scaduta": "Scaduta",
  "da_pagare": "Da pagare",
  "pagata": "Pagata",
  "residuo": "Residuo",
  "gia_versato": "Già versato",
  "rivalsa_autista": "Rivalsa sull'autista",
  "rivalsa_senza_autista": "Il piano di rientro vale solo per le multe a carico dell'autista",
  "piano_rientro": "Piano di rientro",
  "anteprima_piano": "Anteprima piano",
  "numero_rate": "Numero rate",
  "prima_rata": "Prima rata",
  "cadenza_mesi": "Cadenza (mesi)",
  "rate_non_valide": "Numero di rate non valido",
  "rate_pagate": "{{paid}} di {{total}} rate",
  "rata": "Rata",
  "segna_pagata": "Segna come pagata",
  "segna_non_pagata": "Segna come non pagata",
  "apri_autista": "Apri autista",
  "rilievo_fotografico": "Rilievo fotografico",
  "sezioni_coperte": "{{done}}/{{total}} sezioni obbligatorie",
  "foto_danno": "Foto del danno",
  "foto_danno_presenti": "{{count}} foto",
  "foto_danno_richiesta": "Serve almeno una foto del danno",
  "censimento_non_configurato": "Tipo di pratica \"Censimento mezzo\" non configurato",
  "censimento_del": "Censimento del",
  "nessun_danno_rilevato": "Nessun danno rilevato",
  "modifiche_rispetto_precedente": "Cosa è cambiato dal censimento precedente",
  "censimento_ora": "Ora",
  "voce": "Voce",
  "censimento_prima": "Prima",
  "aggiungi_foto": "Aggiungi foto",
  "foto_mancante": "Foto mancante",
  "apri_foto": "Apri foto",
  "ora_puoi_allegare_foto": "Segnalazione creata: ora puoi allegare le foto.",
  "photo_section_body_front": "Parte anteriore",
  "photo_section_body_rear": "Parte posteriore",
  "photo_section_body_left": "Fiancata sinistra",
  "photo_section_body_right": "Fiancata destra",
  "photo_section_passenger_compartment": "Vano passeggeri e interni",
  "photo_section_seats": "Sedili",
  "photo_section_flooring": "Pavimentazione",
  "photo_section_ramp_lift": "Pedana / sollevatore",
  "photo_section_damage_detail": "Foto del danno",
  "apri_mezzo": "Apri mezzo",
  "mezzi_bloccati": "{{count}} mezzo con un danno bloccante aperto.",
  "mezzi_bloccati_plural": "{{count}} mezzi con un danno bloccante aperto.",
  "vehicle_maintenance_process": "Manutenzione in corso",
  "process_status_open": "Aperta",
  "process_status_closed": "Chiusa",
  "process_status_cancelled": "Annullata",
  "campo_testo_lungo": "Testo lungo",
  "campo_check": "Sì / No",
  "errore_upload_foto": "Errore durante il caricamento della foto",
  "upload_in_corso": "Caricamento in corso…",
  "pratiche": "Pratiche",
  "tipi_pratica": "Tipi di pratica",
  "nuovo_tipo_pratica": "Nuovo tipo pratica",
  "modifica_tipo_pratica": "Modifica tipo pratica",
  "nessun_tipo_pratica": "Configura prima un tipo di pratica.",
  "nessun_tipo_pratica_hint": "Puoi partire dalle pipeline predefinite (manutenzione mezzo, assunzione autista) e modificarle.",
  "carica_pipeline_predefinite": "Carica pipeline predefinite",
  "sicuro_rimuovi_tipo_pratica": "Eliminare questo tipo di pratica? Le pratiche già aperte restano, ma non saranno più modificabili.",
  "stage_pratica": "Passaggi della pratica",
  "campi_pratica": "Campi validi per tutta la pratica",
  "aggiungi_stage": "Aggiungi passaggio",
  "nuovo_stage": "Nuovo passaggio",
  "stage_finale": "Finale",
  "stage_annullamento": "Annullamento",
  "stage_chiude_pratica": "Questo passaggio chiude la pratica",
  "stage_esito_positivo": "Esito positivo (altrimenti: annullata)",
  "anteprima_percorso": "Anteprima percorso",
  "percorso_stage": "Percorso",
  "entita_riferimento": "Entità di riferimento",
  "process_subject_vehicle": "Mezzo",
  "process_subject_driver": "Autista",
  "process_subject_company": "Azienda",
  "process_subject_none": "Nessuno",
  "nessun_campo_stage": "Nessun campo richiesto in questo passaggio.",
  "sposta_su": "Sposta su",
  "sposta_giu": "Sposta giù",
  "avanza_pratica": "Avanza",
  "storico_pratica": "Storico passaggi",
  "pratica_chiusa": "Pratica chiusa.",
  "nessuna_pratica": "Nessuna pratica aperta",
  "pratiche_aperte": "Pratiche aperte",
  "apri_pratica": "Apri pratica",
  "nuova_pratica": "Nuova pratica",
  "tipo_pratica_obbligatorio": "Seleziona il tipo di pratica",
  "soggetto_obbligatorio": "Seleziona il soggetto",
  "gestisci_pratica": "Gestisci pratica",
  "pratica_aperta": "Pratica aperta",
  "sicuro_rimuovi_pratica": "Eliminare questa pratica?",
  "priorita": "Priorità",
  "origine": "Origine",
  "aperta_da": "Aperta da",
  "cruscotto": "Cruscotto",
  "pipeline_manutenzione_assente": "Nessuna pipeline di manutenzione configurata: caricala dai tipi di pratica per gestire le lavorazioni a step.",
  "process_priority_low": "Bassa",
  "process_priority_normal": "Normale",
  "process_priority_high": "Alta",
  "process_priority_urgent": "Urgente",
  "process_origin_damage": "Danno",
  "process_origin_deadline": "Scadenza",
  "process_origin_manual": "Manuale",
  "manutenzione_da_danno": "Manutenzione da segnalazione danno",
  "rifornimenti": "Rifornimenti",
  "nuovo_rifornimento": "Nuovo rifornimento",
  "modifica_rifornimento": "Modifica rifornimento",
  "nessun_rifornimento": "Nessun rifornimento",
  "sicuro_rimuovi_rifornimento": "Eliminare questo rifornimento?",
  "dati_rifornimento": "Dati del rifornimento",
  "vehicle_refuel": "Rifornimento",
  "vehicle_inspection": "Censimento mezzo",
  "censimento": "Censimento",
  "censimenti": "Censimenti",
  "censimento_mezzo": "Censimento mezzo",
  "nuovo_censimento": "Nuovo censimento",
  "riprendi_censimento": "Riprendi censimento",
  "chiudi_censimento": "Chiudi censimento",
  "nessun_censimento": "Nessun censimento",
  "sicuro_rimuovi_censimento": "Eliminare questo censimento?",
  "censimento_in_bozza": "C'è già un censimento in bozza da completare.",
  "inizia_dal_punto_zero": "Il primo censimento è il punto zero: la base con cui si confrontano tutti i controlli mensili.",
  "ultimo_censimento": "Ultimo censimento",
  "mai_censito": "Mai censito",
  "da_censire": "Da censire",
  "giorni_fa": "{{count}} giorni fa",
  "mezzi_da_censire": "{{count}} mezzi senza un censimento negli ultimi 30 giorni.",
  "mezzi_da_censire_titolo": "Mezzi da censire",
  "flotta_censita": "Tutti i mezzi sono stati censiti nell'ultimo mese",
  "rilevazioni": "rilevazioni",
  "sintesi_stato_veicolo": "Sintesi stato veicolo",
  "scadenze_documenti": "Scadenze, manutenzione e documenti",
  "pneumatici": "Pneumatici",
  "pneumatico": "Pneumatico",
  "allestimento_sicurezza": "Allestimento, sicurezza e accessori",
  "danni_e_interventi": "Danni e interventi rilevati",
  "chiusura_rilevazione": "Chiusura rilevazione",
  "data_e_ora_censimento": "Data e ora censimento",
  "rilevatore": "Rilevatore",
  "km_rilevati": "Km rilevati",
  "veicolo_funzionante": "Veicolo funzionante",
  "idoneo_al_servizio": "Idoneo al servizio",
  "stato_generale": "Stato generale",
  "pulizia_interna": "Pulizia interna",
  "note_sintetiche": "Note sintetiche",
  "stato_usura": "Stato usura",
  "da_sostituire": "Da sostituire",
  "intervento_necessario": "Intervento necessario",
  "interventi_da_aprire": "Interventi necessari",
  "nessun_intervento_necessario": "Nessun intervento necessario",
  "danni_rilevati": "Danni rilevati in questo censimento",
  "esito_finale": "Esito finale",
  "esito_suggerito": "Suggerito in base alla compilazione:",
  "esito_obbligatorio": "Seleziona l'esito finale",
  "sezioni_incomplete": "Sezioni ancora incomplete: {{list}}",
  "interventi_urgenti": "Interventi urgenti",
  "voci_compilate": "{{done}}/{{total}} voci compilate",
  "confronto_con_precedente": "Confronto con {{kind}} del {{date}}",
  "primo_censimento": "Punto zero: non c'è un censimento precedente",
  "nessuna_variazione": "Nessuna variazione rispetto al censimento precedente",
  "nuovi_danni": "Nuovi danni",
  "nuovi_interventi": "Nuovi interventi",
  "interventi_chiusi": "Interventi chiusi",
  "km_percorsi": "Km percorsi",
  "compilazione": "Compilazione",
  "bozza": "Bozza",
  "chiusi": "Chiusi",
  "trend_improved": "Migliorato",
  "trend_worsened": "Peggiorato",
  "trend_same": "Cambiato",
  "inspection_section_summary": "Sintesi",
  "inspection_section_tyres": "Pneumatici",
  "inspection_section_equipment": "Allestimento",
  "inspection_field_general_condition": "Stato generale",
  "inspection_field_operational": "Veicolo funzionante",
  "inspection_field_fit_for_service": "Idoneo al servizio",
  "inspection_field_cleanliness": "Pulizia interna",
  "inspection_kind_zero": "Punto zero",
  "inspection_kind_monthly": "Controllo mensile",
  "inspection_outcome_compliant": "Conforme",
  "inspection_outcome_usable_with_works": "Utilizzabile con interventi",
  "inspection_outcome_not_usable": "Non utilizzabile",
  "operational_state_yes": "Sì",
  "operational_state_limited": "Con limitazioni",
  "operational_state_no": "No",
  "fitness_state_yes": "Sì",
  "fitness_state_to_verify": "Da verificare",
  "fitness_state_no": "No",
  "condition_state_good": "Buono",
  "condition_state_fair": "Discreto",
  "condition_state_poor": "Mediocre",
  "condition_state_critical": "Critico",
  "cleanliness_state_compliant": "Conforme",
  "cleanliness_state_to_improve": "Da migliorare",
  "cleanliness_state_non_compliant": "Non conforme",
  "tyre_position_front_left": "Anteriore SX",
  "tyre_position_front_right": "Anteriore DX",
  "tyre_position_rear_left": "Posteriore SX",
  "tyre_position_rear_right": "Posteriore DX",
  "wear_state_good": "Buono",
  "wear_state_medium": "Medio",
  "wear_state_critical": "Critico",
  "intervention_urgency_no": "No",
  "intervention_urgency_yes": "Sì",
  "intervention_urgency_urgent": "Urgente",
  "equipment_item_ramp_lift": "Pedana / sollevatore",
  "equipment_item_wheelchair_retractors": "Arrotolatori / fissaggio carrozzina",
  "equipment_item_belts": "Cinture / sistemi di ritenuta",
  "equipment_item_seats": "Sedili e rivestimenti",
  "equipment_item_flooring": "Pavimentazione",
  "equipment_item_doors": "Porte / serrature",
  "equipment_item_glass": "Vetri / specchi",
  "equipment_item_livery": "Vetrofanie / loghi / segnaletica",
  "equipment_item_onboard_kit": "Dotazioni di bordo",
  "equipment_item_other": "Altro",
  "equipment_state_ok": "OK",
  "equipment_state_worn": "Usurato",
  "equipment_state_broken": "Guasto",
  "quantita": "Quantità",
  "prezzo_unitario": "Prezzo unitario",
  "distributore": "Distributore",
  "codice_tessera": "Codice tessera",
  "consumo": "Consumo",
  "spesa": "Spesa",
  "mezzo_obbligatorio": "Seleziona il mezzo",
  "quantita_obbligatoria": "Inserisci una quantità valida",
  "importo_obbligatorio": "Inserisci un importo valido",
  "refueling_provider_dkv": "DKV",
  "refueling_provider_atlante": "Atlante",
  "refueling_provider_hub": "Hub",
  "refueling_provider_manual": "Manuale",
  "refueling_type_fuel": "Carburante",
  "refueling_type_electric": "Ricarica elettrica",
  "refueling_type_adblue": "AdBlue",
  "importa_rifornimenti": "Importa rifornimenti",
  "importa_per_iniziare": "Carica un export mensile del fornitore per popolare i dati.",
  "costo_km": "Costo / km",
  "id_transazione": "ID transazione",
  "gestore_mancante": "Gestore non determinato",
  "nessun_mezzo_per_import": "Nessun mezzo in anagrafica: le targhe non sarebbero risolvibili.",
  "import_targa_non_trovata": "targa non presente in anagrafica",
  "import_data_non_valida": "data non valida",
  "import_quantita_non_valida": "quantità non valida",
  "import_importo_non_valido": "importo non valido",
  "sincronizza_dkv": "Sincronizza DKV",
  "sync_dkv_esito": "DKV: {{created}} nuovi, {{skipped}} già presenti, {{unmatched}} senza mezzo",
  "sync_dkv_errore": "Sincronizzazione DKV fallita",
  "costi": "Costi",
  "nessun_costo": "Nessun costo registrato",
  "nessun_costo_hint": "I costi arrivano da rifornimenti, interventi di manutenzione e danni con importo.",
  "costo_riparazione": "Costo riparazione (€)",
  "carburante": "Carburante",
  "costo_km_non_calcolabile": "Servono almeno due letture del contachilometri",
  "costo_km_su_mezzi": "Su {{count}} mezzi · {{km}} km percorsi",
  "km_percorsi_letture": "{{km}} km su {{count}} letture",
  "nota_costi": "Cosa comprende",
  "nota_costi_testo": "Costo d'esercizio: carburante, interventi di manutenzione e danni con importo. Non comprende ammortamento, valore residuo né i canoni dei contratti di noleggio.",
  "km_inferiori_conferma": "Il mezzo risulta a {{current}} km e stai registrando {{value}} km. Salvare comunque?",
  "km_salto_conferma": "Salto di {{jump}} km rispetto agli ultimi {{current}} registrati. Salvare comunque?",
  "tipo_contratto": "Tipo di contratto",
  "contratto_specifica": "Specifica il contratto",
  "contratto_non_registrato": "Non registrato",
  "contratto_in_corso": "Contratto in corso",
  "storico_contrattuale": "Storico contrattuale",
  "nuovo_contratto": "Nuovo contratto",
  "modifica_contratto": "Modifica contratto",
  "nessun_contratto_registrato": "Nessun contratto registrato",
  "nessun_contratto_in_corso": "Nessun contratto in corso",
  "nessun_contratto_in_corso_desc": "Registra il contratto applicato indicando la data di decorrenza.",
  "sicuro_rimuovi_contratto": "Eliminare questa voce dallo storico contrattuale? Per una variazione, aggiungi un nuovo contratto invece di cancellare.",
  "contract_type_ccnl_commercio": "CCNL Commercio",
  "contract_type_ccnl_autorimesse_ncc": "CCNL Autorimesse / NCC",
  "contract_type_partita_iva": "Partita IVA",
  "contract_type_altro": "Altro",
  "contract_state_current": "In corso",
  "contract_state_future": "Futuro",
  "contract_state_ended": "Concluso",
  "data_decorrenza": "Data di decorrenza",
  "data_fine_eventuale": "Data di fine (se prevista)",
  "tempo_indeterminato": "Tempo indeterminato",
  "livello_qualifica": "Livello / qualifica",
  "ore_settimanali": "Ore settimanali",
  "contratto_indeterminato_hint": "Senza data di fine il contratto è considerato a tempo indeterminato.",
  "contratto_tipo_obbligatorio": "Tipo di contratto obbligatorio.",
  "contratto_altro_obbligatorio": "Specifica il contratto nel campo \"Altro\".",
  "contratto_decorrenza_obbligatoria": "Data di decorrenza obbligatoria.",
  "contratto_date_incoerenti": "La data di fine precede la decorrenza.",
  "limitazioni_autorizzazioni": "Limitazioni e autorizzazioni",
  "limitazioni": "Limitazioni",
  "limitazioni_operative": "Limitazioni operative",
  "tipo_limitazione": "Tipo di limitazione",
  "descrizione_limitazione": "Descrizione",
  "nuova_limitazione": "Nuova limitazione operativa",
  "modifica_limitazione": "Modifica limitazione",
  "aggiungi_limitazione": "Aggiungi limitazione",
  "nessuna_limitazione": "Nessuna limitazione",
  "nessuna_limitazione_desc": "Le limitazioni registrate qui avvisano l'operatore quando il servizio richiede un requisito incompatibile.",
  "sicuro_rimuovi_limitazione": "Eliminare questa limitazione dallo storico? Per una che non vale più, usa \"Revoca\" invece di cancellare.",
  "limitation_type_no_wheelchair_push": "Non può spingere carrozzine",
  "limitation_type_no_architectural_barriers": "Non può fare servizi con barriere architettoniche",
  "limitation_type_no_lifting": "Non può sollevare pesi / allettati",
  "limitation_type_no_oxygen": "Non abilitato alla gestione ossigeno",
  "limitation_type_no_passenger_assistance": "Non può assistere il passeggero",
  "limitation_type_altro": "Altro",
  "limitation_state_active": "Attiva",
  "limitation_state_to_verify": "Da verificare",
  "limitation_state_scheduled": "Programmata",
  "limitation_state_revoked": "Revocata",
  "limitazione_origine": "Origine / segnalata da",
  "requisiti_bloccati": "Requisiti bloccati",
  "nessun_impatto": "Nessun impatto operativo",
  "impatto_pianificazione": "Impatto sulla pianificazione",
  "limitazione_blocca_hint": "Assegnando un servizio che richiede questi requisiti, l'operatore verrà avvisato.",
  "limitazione_senza_impatto_hint": "Questo tipo non è legato a un requisito di servizio: resta a storico come nota operativa, senza avvisi in fase di assegnazione.",
  "limitazione_indeterminata_hint": "Senza data di fine la limitazione è a tempo indeterminato.",
  "limitazione_scadenza_hint": "Alla data di fine la limitazione non viene eliminata: passa in \"Da verificare\" e richiede una conferma o una revoca.",
  "limitazione_tipo_obbligatorio": "Tipo di limitazione obbligatorio.",
  "limitazione_descrizione_obbligatoria": "Descrivi la limitazione.",
  "limitazione_inizio_obbligatorio": "Data di inizio obbligatoria.",
  "limitazione_date_incoerenti": "La data di fine precede quella di inizio.",
  "limitazioni_da_verificare_n": "{{count}} da verificare",
  "limitazioni_tutte": "Limitazioni: tutti",
  "limitazioni_con": "Con limitazioni",
  "limitazioni_da_verificare": "Limitazioni da verificare",
  "limitazioni_senza": "Senza limitazioni",
  "conferma_proroga": "Conferma / proroga",
  "conferma_proroga_limitazione": "Conferma o proroga",
  "revoca": "Revoca",
  "revoca_limitazione": "Revoca limitazione",
  "nuova_data_fine": "Nuova data di fine",
  "motivo_revoca": "Motivo della revoca",
  "note_verifica": "Note della verifica",
  "verificata_il": "Verificata il",
  "revocata_il": "Revocata il",
  "proroga_senza_data_hint": "Senza una nuova data di fine la limitazione diventa a tempo indeterminato.",
  "deadline_cat_driver_limitation": "Limitazione autista",
  "driver_limitation": "Limitazione operativa dell'autista",
  "assegnazioni_incompatibili": "Assegnazioni incompatibili",
  "nessuna_incompatibilita": "Nessuna incompatibilità",
  "capability_push_wheelchair": "Spinta carrozzina",
  "capability_architectural_barriers": "Barriere architettoniche",
  "capability_stretcher_lifting": "Sollevamento allettati",
  "capability_oxygen_handling": "Gestione ossigeno",
  "capability_passenger_assistance": "Assistenza al passeggero",
  "capability_conflict_message": "Limitazione operativa incompatibile: {{summary}}",
  "autorizzazioni": "Autorizzazioni",
  "nuova_autorizzazione": "Nuova autorizzazione",
  "modifica_autorizzazione": "Modifica autorizzazione",
  "aggiungi_autorizzazione": "Aggiungi autorizzazione",
  "nessuna_autorizzazione": "Nessuna autorizzazione registrata",
  "nessuna_autorizzazione_desc": "Finché non c'è un record con il documento firmato, la liberatoria risulta \"Documento mancante\".",
  "sicuro_rimuovi_autorizzazione": "Eliminare questa autorizzazione dallo storico? Per una revoca, imposta lo stato \"Revocato\" invece di cancellare.",
  "policy": "Policy",
  "policy_image_release": "Liberatoria immagini",
  "liberatoria_immagini": "Liberatoria immagini",
  "liberatoria_tutte": "Liberatoria: tutti",
  "authorization_state_authorized": "Autorizzato",
  "authorization_state_not_authorized": "Non autorizzato",
  "authorization_state_revoked": "Revocato",
  "authorization_state_missing_document": "Documento mancante",
  "finalita_autorizzate": "Finalità autorizzate",
  "purpose_internal": "Uso interno",
  "purpose_website": "Sito web",
  "purpose_social": "Social network",
  "purpose_press": "Stampa e comunicati",
  "purpose_recruiting": "Selezione del personale",
  "purpose_commercial": "Materiale commerciale",
  "data_sottoscrizione": "Data di sottoscrizione",
  "data_revoca": "Data di revoca",
  "documento_firmato": "Documento firmato",
  "carica_documento": "Carica documento",
  "sostituisci_documento": "Sostituisci documento",
  "scollega": "Scollega",
  "non_allegato": "Non allegato",
  "documento_richiesto_hint": "Senza il documento firmato l'autorizzazione resta in \"Documento mancante\".",
  "documento_facoltativo_hint": "Documento facoltativo.",
  "upload_gestore_mancante": "Impossibile caricare: autista senza gestore associato.",
  "caricamento_riuscito": "Documento caricato",
  "policy_obbligatoria": "Policy obbligatoria.",
  "data_sottoscrizione_obbligatoria": "Data di sottoscrizione obbligatoria per un'autorizzazione.",
  "data_revoca_obbligatoria": "Data di revoca obbligatoria.",
  "revoca_prima_sottoscrizione": "La revoca precede la sottoscrizione.",
  "finalita_obbligatorie": "Indica almeno una finalità autorizzata.",
  "cancellation_reason_customer_request": "Annullamento richiesto dal cliente/utente",
  "cancellation_reason_appointment_cancelled": "Appuntamento o visita annullata/rinviata",
  "cancellation_reason_health_status_changed": "Ricovero, dimissione o situazione sanitaria modificata",
  "cancellation_reason_other_transport": "Trasporto organizzato con altra soluzione",
  "cancellation_reason_booking_error": "Errore di prenotazione / servizio duplicato",
  "cancellation_reason_service_rebooked": "Modifica del servizio con nuova prenotazione",
  "cancellation_reason_user_not_transportable": "Utente non trasportabile / requisiti non compatibili",
  "cancellation_reason_no_show": "No-show / utente non presente",
  "cancellation_reason_mbility_unavailable": "Annullamento per indisponibilità Mbility",
  "cancellation_reason_vehicle_unavailable": "Problema tecnico / mezzo indisponibile",
  "cancellation_reason_force_majeure": "Forza maggiore / causa esterna",
  "cancellation_reason_other": "Altro",
  "causale_annullamento": "Causale annullamento",
  "seleziona_causale": "Seleziona una causale…",
  "nota": "Nota",
  "nota_obbligatoria": "Nota obbligatoria per \"Altro\"",
  "nota_facoltativa": "Nota (facoltativa)",
  "annulla_viaggio": "Annulla viaggio",
  "annulla_n_viaggi": "Annulla {{count}} viaggi",
  "adv_channel_google": "Google",
  "adv_channel_facebook": "Facebook",
  "adv_channel_instagram": "Instagram",
  "adv_channel_email": "Email",
  "adv_channel_flyer": "Volantino",
  "adv_channel_qr_code": "QR-Code",
  "adv_channel_word_of_mouth": "Passaparola",
  "adv_channel_healthcare_facility": "RSA/Ospedale",
  "adv_channel_billboard": "Cartelloni",
  "adv_channel_brevo_chatbot": "Chatbot Brevo",
  "adv_channel_existing_customer": "Già cliente",
  "adv_channel": "Canale di provenienza",
  "seleziona_canale": "Seleziona un canale…",
  "canale_provenienza": "Canale di provenienza",
  "nascondi_non_specificato": "Nascondi non specificato",
  "non_specificato": "Non specificato",
  "linea_business": "Linea di business",
  "seleziona_linea_business": "Nessuna linea assegnata",
  "prezzo_al_km": "Prezzo al km (€)",
  "validita": "Validità",
  "valido_dal": "Valido dal",
  "valido_al": "Valido al",
  "sempre_valido": "Sempre valido",
  "fine_prima_inizio": "La data di fine precede quella di inizio",
  "periodo_validita_non_valido": "Il periodo di validità non è valido: controlla le date.",
  "tipo_servizio": "Tipo servizio",
  "validi_e_futuri": "Validi e futuri",
  "validi_oggi": "Validi oggi",
  "programmati": "Programmati",
  "scaduti": "Scaduti",
  "archiviati": "Archiviati",
  "in_servizio": "In servizio",
  "programmato": "Programmato",
  "archiviato": "Archiviato",
  "nessun_pianificato_per_filtro": "Nessun pianificato per il filtro scelto",
  "di_n_totali": "di {{total}} totali",
  "analytics_autisti": "Analytics autisti",
  "occupazione_autisti_sottotitolo": "Occupazione, capacità e ritardi per giorno e fascia oraria",
  "occupazione": "Occupazione",
  "imposta_i_filtri": "Imposta i filtri",
  "avvia_analisi_occupazione": "Scegli periodo, gestori e commesse, poi premi Applica per calcolare l’occupazione.",
  "errore_di_caricamento": "Errore di caricamento",
  "errore_caricamento_occupazione": "Non è stato possibile caricare l’occupazione. Riprova.",
  "saturazione_media": "Saturazione media",
  "nessun_turno_nel_periodo": "Nessun turno nel periodo",
  "tempo_occupato": "Tempo occupato",
  "capacita": "Capacità",
  "tempo_tra_servizi": "Tempo tra servizi",
  "sovrapposizioni": "Sovrapposizioni",
  "nota_tempo_a_vuoto": "Il tempo di trasferimento non è registrato come dato a sé: viene misurato come “tempo tra servizi”, che comprende anche attese e pause non registrate.",
  "nota_pooling_stimato": "giri in pooling non hanno il percorso registrato: la durata è stimata dagli orari di presa.",
  "nota_tempi_reali": "Troppi ordini nel periodo per ricostruire tutti i tempi reali: la puntualità mostrata è parziale.",
  "nota_annullati": "Troppi annullamenti nel periodo per datarli tutti: sono inclusi solo quelli registrati con lo stato dedicato.",
  "riepilogo_mensile": "Riepilogo mensile",
  "avvia_riepilogo_autisti": "Scegli periodo e gestori, poi premi Applica.",
  "performance": "Performance",
  "avvia_confronto_performance": "Scegli periodo e gestori, poi premi Applica per confrontare i punteggi.",
  "errore_caricamento_performance": "Non è stato possibile calcolare i punteggi. Riprova.",
  "performance_nota_copertura": "Un “—” significa dato insufficiente per quel componente, non una prestazione scarsa: i componenti senza copertura escono dal calcolo e il loro peso è ridistribuito.",
  "giri_in_pooling": "Pooling",
  "tempo_di_ritorno": "Ritorno",
  "trasferimento_a_vuoto": "Trasferimento",
  "nessun_mezzo_assegnato": "Nessun mezzo assegnato in quella giornata.",
  "mezzo_senza_gps": "Il mezzo assegnato non ha un identificativo GPS.",
  "nessun_punto_gps": "Nessuna posizione registrata in quest’ora.",
  "errore_tracciato": "Non è stato possibile caricare il tracciato.",
  "sovrapposizione": "Sovrapposizione",
  "tratte": "tratte",
  "in_partenza": "in partenza",
  "in_arrivo": "in arrivo",
  "durata_stimata": "durata stimata",
  "vedi_tracciato": "Vedi tracciato",
  "tracciato_del_mezzo": "Tracciato del mezzo assegnato: l’associazione autista-veicolo può cambiare nel corso della giornata.",
  "dettaglio_cella": "Dettaglio cella",
  "errore_dettaglio_cella": "Non è stato possibile caricare il dettaglio.",
  "nessuna_attivita": "Nessuna attività",
  "nessun_autista_in_questa_ora": "In quest’ora nessun autista risulta occupato né in turno.",
  "tutte_le_commesse": "Tutte le commesse",
  "selezionate": "selezionate",
  "nessuna_commessa": "Nessuna commessa",
  "pause_come_capacita": "Pause come capacità",
  "passa_sulla_cella_per_il_dettaglio": "Passa sulla cella per il riepilogo, clicca per il dettaglio autisti",
  "nascondi_ore_vuote": "Nascondi ore vuote",
  "viaggi_ricorrenti": "Viaggi ricorrenti",
  "non_disponibile": "Non disponibile",
  "permesso": "Permesso",
  "minuti_capacita": "Minuti capacità",
  "autisti_occupati": "Autisti occupati",
  "autisti_liberi": "Autisti liberi",
  "saturazione": "Saturazione",
  "tempo_libero": "Tempo libero",
  "composizione": "Composizione",
  "trasferimenti_e_attese": "Trasferimenti e attese",
  "doppia_prenotazione": "Doppia prenotazione",
  "ritardi": "Ritardi",
  "ritardo_partenza": "Ritardo partenza",
  "ritardo_arrivo": "Ritardo arrivo",
  "puntualita": "Puntualità",
  "dati_insufficienti": "dati insufficienti",
  "per_assenza": "di cui per assenza",
  "capacita_sprecata": "Capacità sprecata",
  "nel_tempo_tra_servizi": "nel tempo tra servizi",
  "non_misurato": "Non misurato",
  "performance_index": "Performance Index",
  "valutazione": "Valutazione",
  "desc_saturazione": "Minuti occupati sui minuti di turno, ora per ora. La cella grigia è “nessun turno”, che non è lo stesso di 0%. In rosso oltre il 100%: lavoro assegnato oltre il turno.",
  "desc_tempo_occupato": "Minuti in cui l’autista è impegnato: servizio, fermo mezzo, ritorno, eventi e trasferimenti. È l’unione degli impegni, quindi due corse sovrapposte non fanno 120 minuti in un’ora.",
  "desc_tempo_libero": "Capacità residua: minuti di turno meno minuti occupati. In rosso i valori negativi: sovraccarico, cioè più lavoro assegnato di quanto il turno ne contenga.",
  "saturazione_autisti": "Saturazione autisti",
  "desc_saturazione_autisti": "Autisti impegnati su quelli in turno, contati a teste: risponde a “quanti mezzi ho ancora liberi”, non a “quanto tempo residuo ho”. Un autista occupato 5 minuti pesa qui come uno occupato 60. In rosso oltre il 100%.",
  "desc_autisti_liberi": "Autisti in turno senza alcun impegno in quell’ora. In rosso i valori negativi: stanno lavorando più autisti di quanti risultino in turno, cioè turni non inseriti o corse assegnate fuori turno.",
  "desc_autisti_occupati": "Autisti con almeno un impegno che tocca quell’ora: basta un minuto per contare.",
  "desc_autisti_in_turno": "Autisti con un turno di capacità attivo (disponibile, extra, presidio). Ferie, malattia e permessi non contano: un autista in ferie non è capacità inutilizzata.",
  "desc_tempo_tra_servizi": "Buchi fra un servizio e il successivo dello stesso autista, dentro il turno. Contengono il trasferimento a vuoto, ma anche attese e pause non registrate: è un limite superiore, non il tempo di guida.",
  "desc_sovrapposizioni": "Minuti assegnati due volte allo stesso autista: doppia prenotazione. Ogni cella con un valore è in rosso — non esiste una soglia accettabile. Si misura sugli orari pianificati, quindi si vede prima che la giornata sia svolta.",
  "desc_ritardi": "Somma dei ritardi in partenza, solo positivi (gli anticipi non compensano), attribuiti all’ora di partenza pianificata. Richiede un tempo reale registrato: dove non c’è, la cella resta vuota.",
  "desc_annullati_24h": "Corse disdette con meno di 24 ore di preavviso, contate nell’ora in cui si sarebbero svolte. Non occupano l’autista: sono capacità sprecata.",
  "scala_soglie_fisse": "Colore su soglie fisse: 25 / 50 / 75 / 100%. Confrontabile fra mesi e gestori diversi.",
  "scala_relativa": "Colore relativo al valore massimo di questa griglia: dice dove si concentra il fenomeno nel mese, non quanto vale rispetto a un altro mese.",
  "senza_autista": "Senza autista assegnato",
  "drivers": "Autisti",
  "foto_evento": "Foto evento",
  "nessuna_foto": "Nessuna foto allegata",
  "anteprima_foto": "Anteprima foto",
  "chiudi_anteprima": "Chiudi anteprima",
  "foto_precedente": "Foto precedente",
  "foto_successiva": "Foto successiva",
  "caricamento_foto": "Caricamento foto…",
  "foto_non_disponibile": "Foto non disponibile",
  "op2_luogo_partenza": "Luogo (secondo operatore in partenza)",
  "op2_luogo_arrivo": "Luogo (secondo operatore in arrivo)",
  "tipologia_carrozzina": "Tipologia carrozzina",
  "copia_viaggio": "Copia viaggio",
  "utenze": "Utenze",
  "nuova_utenza": "Nuova utenza",
  "modifica_utenza": "Modifica utenza",
  "elimina_utenza": "Elimina utenza",
  "disattiva_utenza": "Disattiva utenza",
  "riattiva_utenza": "Riattiva utenza",
  "nessuna_utenza": "Nessuna utenza",
  "nessuna_utenza_msg": "Crea un'utenza per dare accesso al portale aziendale.",
  "utenza_attiva": "Utenza attiva (può accedere)",
  "nuova_password_opzionale": "Nuova password (lascia vuoto per non cambiarla)",
  "ruolo_account_b2b": "Portale aziendale",
  "ruolo_account_cdi": "Centro diurno",
  "sicuro_elimina_utenza": "L'utenza non potrà più accedere al portale e verrà eliminata definitivamente. Per sospenderla soltanto, usa Disattiva. Continuare?",
  "tipo_check": "Tipo di check",
  "check_inizio_giornata": "Inizio giornata",
  "check_durante_giornata": "Durante la giornata",
  "check_da_menu": "Check giornaliero",
  "livello_carburante": "Livello carburante",
  "pulizia_mezzo": "Pulizia del mezzo",
  "carburante_pieno": "Pieno",
  "carburante_tre_quarti": "3/4",
  "carburante_meta": "1/2",
  "carburante_un_quarto": "1/4",
  "carburante_riserva": "Riserva",
  "pulizia_buona": "Buona",
  "pulizia_sufficiente": "Sufficiente",
  "pulizia_insufficiente": "Insufficiente",
  "controlli_mezzo": "Controlli mezzo",
  "controllo_spie": "Spie / anomalie cruscotto",
  "controllo_pneumatici": "Pneumatici",
  "controllo_luci": "Luci",
  "controllo_pedana": "Pedana / sollevatore",
  "controllo_ancoraggi": "Ancoraggi carrozzina",
  "controllo_cinture": "Cinture passeggeri",
  "dotazione_gradino": "Gradino",
  "dotazione_carrozzina": "Carrozzina in dotazione",
  "dotazione_estintore": "Estintore",
  "dotazione_pocket_mask": "Pocket Mask",
  "dotazione_pos": "POS presente e funzionante",
  "dotazione_divisa": "Divisa indossata",
  "anomalia_segnalata": "Anomalia segnalata",
  "nessuna_anomalia": "Nessuna anomalia",
  "note_check": "Note dell'autista",
  "voci_non_conformi": "Voci non conformi",
  "check_senza_controlli": "Compilato dal menu dell'app: nessun controllo",
  "esito_check": "Esito",
  "cerca_indirizzo": "Cerca indirizzo",
  "cerca_indirizzo_placeholder": "Via, numero civico, città",
  "filtra_viaggi": "Passeggero o indirizzo",
  "mostra_tutti": "Mostra tutti",
  "mezzi_live_one": "{{count}} mezzo in tempo reale",
  "mezzi_live_other": "{{count}} mezzi in tempo reale",
  "aggiornato_alle": "aggiornato alle {{time}}",
  "velocita": "Velocità",
  "corsa": "Corsa",
  "giro": "Giro",
  "senza_posizione": "nessuna posizione",
  "rientro": "Rientro",
  "wait_time_manual": "orario inserito dall'autista",
  "fermo_auto_orario_manuale": "L'orario dell'attesa è stato inserito dall'autista, non misurato dall'app.",
  "tooltip_wait_open": "In attesa dalle {{from}} · previsti {{planned}} min",
  "tooltip_wait_done": "Attesa {{from}} → {{to}} · {{minutes}} min (previsti {{planned}})",
  "tooltip_passengers": "{{n}} passeggeri",
  "tooltip_wheelchairs": "{{n}} in carrozzina",
  "tooltip_absent": "{{n}} assenti",
  "tooltip_group_progress": "A bordo {{onBoard}} · trasportati {{done}}/{{total}}",
  "tooltip_others": "+{{n}} altri",
  "mancano_minuti": "mancano {{count}} min",
  "oltre_minuti": "oltre di {{count}} min",
  "viaggi_annullati": "Viaggi annullati",
  "viaggi_annullati_riepilogo": "{{trips}} viaggi annullati · {{users}} utenti · {{withDriver}} con autista",
  "viaggi_annullati_n_one": "{{count}} viaggio annullato",
  "viaggi_annullati_n_other": "{{count}} viaggi annullati",
  "nessun_viaggio_annullato": "Nessun viaggio annullato nel periodo",
  "cerca_utente_indirizzo": "Cerca utente o indirizzo…",
  "solo_con_autista": "Solo con autista assegnato",
  "senza_utente": "Senza utente",
  "utente": "Utente",
  "annullato_il": "Annullato il",
  "non_assegnato": "Non assegnato",
  "con_autista_n_one": "{{count}} con autista",
  "con_autista_n_other": "{{count}} con autista",
  "ripristina": "Ripristina",
  "ripristina_viaggi": "Ripristina viaggi",
  "ripristina_viaggio": "Ripristina questo viaggio",
  "ripristina_tutti_n_one": "Ripristina il viaggio",
  "ripristina_tutti_n_other": "Ripristina tutti i {{count}} viaggi",
  "ripristina_conferma_uno": "Il viaggio di {{name}} del {{when}} torna in servizio.",
  "ripristina_conferma_molti_one": "Un viaggio torna in servizio.",
  "ripristina_conferma_molti_other": "{{count}} viaggi tornano in servizio.",
  "ripristina_stato_recap": "{{assigned}} tornano Assegnati (hanno già un autista), {{inserted}} tornano Inseriti.",
  "autista_gia_assegnato": "Autista già assegnato",
  "ripristina_avviso_autista": "Questi viaggi tornano direttamente in stato Assegnato: verifica che l'autista sia ancora disponibile in quella fascia oraria.",
  "ripristina_causale_rimossa": "La causale di annullamento viene rimossa dal viaggio; il cambio di stato resta tracciato nello storico.",
  "viaggi_ripristinati_n_one": "Viaggio ripristinato",
  "viaggi_ripristinati_n_other": "{{count}} viaggi ripristinati",
  "ripristino_fallito": "Ripristino non riuscito",
  "ripristina_esclusi_passati_one": "Un viaggio è escluso: è di un giorno passato e non si può ripristinare.",
  "ripristina_esclusi_passati_other": "{{count}} viaggi sono esclusi: sono di giorni passati e non si possono ripristinare.",
  "non_ripristinabile_passato": "Non ripristinabile: il viaggio è di un giorno passato",
  "nessun_viaggio_ripristinabile": "Nessun viaggio ripristinabile: si ripristinano solo i viaggi da oggi in poi",
  "raggruppa_per_utente": "Raggruppa per utente",
  "espandi": "Espandi",
  "comprimi": "Comprimi",
  "ripristina_per_date": "Ripristina per date",
  "seleziona_periodo": "Seleziona periodo",
  "seleziona_tutto": "Seleziona tutto",
  "deseleziona_tutto": "Deseleziona tutto",
  "senza_data": "Senza data",
  "date_selezionate_n": "{{dates}} date selezionate · {{trips}} viaggi",
  "spunta_date_periodo": "Spunta le date del periodo",
  "orario_non_disponibile": "orario non disponibile"
}
